import React from "react";
import { useRef, useEffect, useState } from "react";
import { Autocomplete, Box, Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, Divider, Grid, IconButton, InputAdornment, ListItem, TextField, Tooltip, Typography } from "@mui/material";
import RateYourExperience from "./RateYourExperience.tsx";
import QuestionsBank from "./QuestionsBank.tsx";
import OtherDetailsScoreCard from "./OtherDetailsScoreCard.tsx";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CustomUploadProfilePic } from "../../../apiService/Core/CustomUploadPic.tsx";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../../Loader/Loading.tsx";
import { useDispatch, useSelector } from "react-redux";
import {
  AldivalidateStep2,
  validateStep1,
  validateStep2,
  validateStep3,
  type ValidationError,
} from "../../ScoreCardValidation/ValidationSchema.tsx";
import SyncIcon from "@mui/icons-material/Sync";
import {
  ApiCallGetReportDetails,
  ApiDeleteReportPhotos,
  ApiDownloadScorecard,
  ApiReviewReport,
  ApiReviewReport2,
  ApiScoreCardStep1,
  ApiScoreCardStep2,
  ApiScoreCardStep3,
  ApiUpdateReportQuestion,
} from "../../../apiService/Core/CustomApiScoreCards.tsx";
import PreviewScoreCard from "./PreviewScoreCard.tsx";
import { CheckBoxOutlineBlankOutlined, CheckCircle, Close, CloseOutlined, DescriptionOutlined, ErrorOutline, ErrorTwoTone, ImportantDevicesOutlined, KeyboardArrowDown, KeyboardArrowUp, NavigateNext, ReportProblemOutlined, Search } from "@mui/icons-material";
import { number } from "yup";
import imageCompression from "browser-image-compression";
import heic2any from "heic2any";
import { hideLoading, showLoading } from "../../../Redux/loadingSlice.tsx";
import issue from '../../../assets/Project_Images/issue.png'
import { ApiDeleteAllocation } from "../../../apiService/Core/Apicall.tsx";

export default function CreateOrEditScoreCard() {
  const fileTypeMap: { [key: string]: string } = {
    taskPhotos: "report_task_photos",
    invoiceReceipt: "report_invoice_photos",
    checkInFile: "report_location_photos",
    checkOutFile: "report_location_photos",
    questionFiles: "report_question_answer",
    shopperBagImages: "shopper_bag_image"
  };

  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [date, setDate] = useState<any>(null);
  const [inspectiontime, setInspectionTime] = useState<any>();
  const [openpopup, setopenpopup] = useState<boolean>(false);
  const [openreviewpopup, setOpenReviewPopup] = useState<boolean>(false);
  const [contactdetails, setContactdetails] = useState<any>('');
  const [ratings, setRatings] = useState<Record<string, number>>({});
  const [isOpenCheckOut, setisOpenCheckOut] = useState(false)
  const [AiReview, setAiReview] = useState<any>([])
  const dispatch = useDispatch()
  const [uploadedFiles, setUploadedFiles] = useState<any>({
    taskPhotos: [],
    invoiceReceipt: [],
    checkInFile: [],
    checkOutFile: [],
    questionFiles: {},
    shopperBagImages: []
  });

  const [invoice, setInvoice] = useState({
    food: 0,
    bar: 0,
    gaming: 0,
    bottleshop: 0,
    retail: 0,
    total: 0,
  });

  // Add state for text inputs to ensure they're controlled components
  const [textInputs, setTextInputs] = useState<any>({});
  const [staffMemberDesc, setStaffMemberDesc] = useState("");
  const [additionalNoteForShopper, setAdditionalNoteForShopper] = useState("");
  const [managerId, setManagerId] = useState(null);
  const [npsData, setnpsData] = useState<any>(null);
  const [scenarioId, setScenarioId] = useState(null);
  const [addOnQuestions, setAddOnQuestions] = useState<any>({});
  const loading = useSelector((state: any) => state.loader.isLoading);
  const [showPreview, setShowPreview] = useState(false);
  const [clientEntityName, setclientEntityName] = useState<string>('')
  const [reportDetails, setReportDetails] = useState<{
    starRatingResponseData: any[];
    briefJsonDataResponse: any[];
    lastReportShopperRatingData: any
    addOnQuestion: any[];
    questions: any[];
    reportHeader: any;
    taskPhotos: any;
    invoicePhotos: any;
    reportOtherDetails: any;
    shopTypeDetail: any;
    entityTypeDetails: any;
    allocationDetails: any;
    venueName: string
  } | null>(null);
  // const { allocationId } = useParams<{ allocationId: string }>();
  const location = useLocation();
  const allocationId = location?.state?.allocationId;
  const clientGroup = location?.state?.clientGroup;

  const localstring = localStorage.getItem('localstring')

  // Add state for validation errors
  const [validationErrors, setValidationErrors] = useState<ValidationError[]>(
    []
  );
  const [showValidationErrors, setShowValidationErrors] = useState(false);

  // State for tracking answers
  const [answers, setAnswers] = useState<any>({});
  const [archieveImages, setarchieveImages] = useState<any>([])
  const [checkOuttime, setcheckOuttime] = useState<any>()
  const [checkIntime, setcheckIntime] = useState<any>()
  const [oldmaxScore, setoldmaxScore] = useState<any>([])
  const liveuser = localStorage.getItem('liveuserRole')
  const [selectedQuestion, setSelectedQuestion] = useState<any>('')
  const bottomRef = useRef<HTMLDivElement | null>(null);
  const topRef = useRef<HTMLDivElement | null>(null);
  const [focused, setFocused] = useState(false);
  const [openReview, setopenReview] = useState(false);
  const [closing, setClosing] = useState(false);
  const questionRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const [isSuccess, setisSuccess] = useState<boolean>(false)
  const overviewRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const questionBankRef = useRef<any>(null);
  const rateRef = useRef<any>(null);
  const isAdmin = (localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor' || localStorage.getItem("liveuserRole") === 'clientadmin')
  const [isDemoAllocation, setisDemoAllocation] = useState<boolean>(false)
  const [selectedMoveImages, setSelectedMoveImages] = useState([])
  const [selecetdvenueData, setselectedVenueData] = useState<any>([])
  const [openVenueDescription, setOpenVenueDescription] = useState<boolean>(false)
  const [isreviewd, setIsReviewed] = useState(false)
  const [openReviewRequired, setOpenReviewRequired] = useState<boolean>(false)
  const [openAllFeildRequired, setOpenAllFeildRequired] = useState<boolean>(false)
  const [navigationStep, setNavigationStep] = useState<number>()
  const [openReviewCompleted, setOpenReviewCompleted] = useState(false)
  const [editorAiReviewCount, setEditorAiReviewCount] = useState(0)



  useEffect(() => {
    if ((localStorage.getItem('liveuserRole') !== 'admin' && localStorage.getItem('liveuserRole') !== 'superadmin' && localStorage.getItem("liveuserRole") !== 'editor')) {
      const handleBeforeUnload = (event: BeforeUnloadEvent) => {
        event.preventDefault();
        event.returnValue = ""; // Some browsers require returnValue to be set
        localStorage.removeItem(`isScoreCardEdited_${allocationId}`);
      };

      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, []);

  const hasConfirmedRef = useRef(false);

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      event.preventDefault();

      if (hasConfirmedRef.current) {
        // If user has already confirmed, allow normal back
        return;
      }

      const confirmLeave = window.confirm(
        "Are you sure you want to leave this page?"
      );
      if (confirmLeave && localstring && localstring?.length > 0) {
        window.close()
      }
      else if (confirmLeave) {
        hasConfirmedRef.current = true;
        localStorage.removeItem(`isScoreCardEdited_${allocationId}`);
        navigate("/dashboard/MyTasks"); // Try to go back again
      } else {
        // Push the current page back to history to cancel the navigation
        window.history.pushState(null, "", window.location.href);
      }
    };

    // Push a fake history entry to trap back button
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  // Function to save form data to localStorage
  const saveFormDataToLocalStorage = () => {
    if (!allocationId) return;
    // console.log("Allocation TIme", inspectiontime)
    // console.log("UploadedFiles---------->", uploadedFiles)
    const formData = {
      date: date ? new Date(date) : null,
      inspectiontime: inspectiontime?.length > 1 ? inspectiontime : null,
      ratings,
      addOnQuestions,
      textInputs,
      staffMemberDesc,
      additionalNoteForShopper,
      managerId,
      npsData,
      scenarioId,
      uploadedFiles,
      invoice,
      answers,
      oldmaxScore,
      archieveImages,
      checkOuttime,
      checkIntime,
      currentStep,
      currentCategoryIndex,
      reportDetails,
    };

    localStorage.setItem(`scorecard_${allocationId}`, JSON.stringify(formData));
    localStorage.setItem(`reportHeaderId`, reportDetails?.reportHeader?.reportHeaderId);
    localStorage.setItem(
      `isScoreCardEdited_${allocationId}`,
      JSON.stringify(true)
    );

  };
  // Save form data whenever any relevant state changes
  useEffect(() => {
    if (allocationId && reportDetails) {
      saveFormDataToLocalStorage();
    }
  }, [
    date,
    inspectiontime,
    ratings,
    textInputs,
    addOnQuestions,
    staffMemberDesc,
    additionalNoteForShopper,
    managerId,
    npsData,
    scenarioId,
    uploadedFiles,
    invoice,
    answers,
    archieveImages,
    checkOuttime,
    checkIntime,
    currentStep,
    currentCategoryIndex,
    oldmaxScore
  ]);

  // 1️⃣ First load localStorage if available
  const loadFormDataFromLocalStorage = () => {
    const savedFormData = localStorage.getItem(`scorecard_${allocationId}`);
    if (savedFormData) {
      try {
        const parsedData = JSON.parse(savedFormData);

        if (parsedData.date) setDate(new Date(parsedData.date));
        if (parsedData.inspectiontime) setInspectionTime(parsedData.inspectiontime);
        if (parsedData.ratings) setRatings(parsedData.ratings);
        if (parsedData.textInputs) setTextInputs(parsedData.textInputs);
        if (parsedData.addOnQuestions)
          setAddOnQuestions(parsedData.addOnQuestions);
        if (parsedData.staffMemberDesc)
          setStaffMemberDesc(parsedData.staffMemberDesc);
        if (parsedData.additionalNoteForShopper)
          setAdditionalNoteForShopper(parsedData.additionalNoteForShopper);
        if (parsedData.managerId)
          setManagerId(parsedData.managerId);
        if (parsedData?.npsData)
          setnpsData(parsedData.npsData)
        if (parsedData.scenarioId)
          setScenarioId(parsedData.scenarioId);
        if (parsedData.uploadedFiles)
          setUploadedFiles(parsedData.uploadedFiles);
        if (parsedData.invoice) setInvoice(parsedData.invoice);
        if (parsedData.answers) setAnswers(parsedData.answers);
        if (parsedData.oldmaxScore) setoldmaxScore(parsedData.oldmaxScore);
        if (parsedData.archieveImages) setarchieveImages(parsedData.archieveImages);
        if (parsedData.checkOuttime) setcheckOuttime(parsedData.checkOuttime);
        if (parsedData.checkIntime) setcheckIntime(parsedData.checkIntime);
        if (parsedData.currentStep) setCurrentStep(parsedData.currentStep);
        if (parsedData.currentCategoryIndex)
          setCurrentCategoryIndex(parsedData.currentCategoryIndex);
        if (parsedData.reportDetails)
          setReportDetails(parsedData.reportDetails);


      } catch (error) {
        console.error("Error parsing saved form data:", error);
      }
    }
  };



  useEffect(() => {
    if (contactdetails) {
      setopenpopup(true)
    }
  }, [contactdetails])

  console.log("AI REView", editorAiReviewCount)

  const fetchData = async () => {
    if (!allocationId) return;

    try {
      const data = `?allocationId=${allocationId}`;
      const response = await ApiCallGetReportDetails(data, clientGroup);
      if (isAdmin) {
        console.log('report Details', response?.data)
      }
      if (isAdmin) {
        setIsReviewed(response?.data?.reportHeader?.isEditorAiReviewCompleted || response?.data?.reportHeader?.editorAiReviewCount > 0)
        setEditorAiReviewCount(response?.data?.reportHeader?.editorAiReviewCount)
      }
      else {
        setIsReviewed(response?.data?.reportHeader?.isShopperAiReviewCompleted)
      }
      setclientEntityName(response?.data?.clientEntityName)
      localStorage.setItem("allocationId", allocationId);
      localStorage.setItem("iap", "true")
      setisDemoAllocation(response?.data?.allocationDetails?.isDemoAllocation)
      const isScoreCardEdited = JSON.parse(
        localStorage.getItem(`isScoreCardEdited_${allocationId}`) || "false"
      );

      if (isScoreCardEdited) {
        loadFormDataFromLocalStorage();
        return;
      }
      // Set latest data into state
      setReportDetails(response.data);
      setContactdetails(response.data.contacts)

      setInvoice({
        food: response?.data?.reportHeader?.spentFoodAmt || 0,
        bar: response?.data?.reportHeader?.spentBarAmt || 0,
        gaming: response?.data?.reportHeader?.spentGamingAmt || 0,
        bottleshop: response?.data?.reportHeader?.spentBottleShopAmt || 0,
        total: response?.data?.reportHeader?.spentAmt || 0,
        retail: response?.data?.entityTypeDetails.entityTypeName?.toLowerCase() === "retail" ? response?.data?.reportHeader?.spentAmt : 0,
      });
      setRatings(
        response.data.starRatingResponseData.reduce(
          (acc, item) => ({
            ...acc,
            [item.reportStarRatingId]: item.starRatingScore,
          }),
          {}
        )
      );

      setTextInputs(
        response.data.briefJsonDataResponse.reduce(
          (acc, item) => ({
            ...acc,
            [item.reportBriefJsonId]: item.briefJsonAnswer || "",
          }),
          {}
        )
      );

      setAddOnQuestions(
        response.data.addOnQuestion.reduce(
          (acc, item) => ({
            ...acc,
            [item.reportAddOnQuestionId]: item.addOnQuestionValue || "",
          }),
          {}
        )
      );

      setStaffMemberDesc(response.data.reportHeader.staffMemberDesc);
      setAdditionalNoteForShopper(response.data.reportHeader.additionalNoteForShopper)
      setManagerId(response.data.allocationDetails?.managerId?.managerId)
      // setnpsData({score:response?.data?.netPromoterScore?.score,title:response?.data?.netPromoterScore?.netPromoterScoreConfigId?.title, netPromoterScoreConfigId:response?.data?.netPromoterScore?.netPromoterScoreConfigId?.netPromoterScoreConfigId})
      setnpsData({
        score: response?.data?.netPromoterScore?.score,
        title: response?.data?.netPromoterScore?.netPromoterScoreConfigId?.title,
        netPromoterScoreConfigId:
          response?.data?.netPromoterScore?.netPromoterScoreConfigId?.netPromoterScoreConfigId,
        feedback: response?.data?.netPromoterScore?.feedback
      })
      setScenarioId(response.data.allocationDetails?.scenarioId?.scenarioId)

      const checkInPhotos =
        response.data.reportHeader?.checkInPhotoUrl != '' ? response.data.reportHeader?.checkInPhotoUrl?.split(", ") : [];
      const checkOutPhotos =
        response.data.reportHeader?.checkOutPhotoUrl != '' ? response.data.reportHeader?.checkOutPhotoUrl?.split(", ") : [];
      const shopperBagPhotos = response.data.reportHeader?.shopperBagImages?.split(", ") ?? [];

      const taskPhotoData =
        response.data.taskPhotos?.map((photo) => ({
          reportHdrImageId: photo.reportHdrImageId,
          imageUrl: photo.imageUrl,
          displayOrder: photo.displayOrder
        })).sort((a: any, b: any) => a.displayOrder - b.displayOrder) || [];
      const invoicePhotos =
        response.data.invoicePhotos?.map((photo) => ({
          reportHdrInvoiceId: photo.reportHdrInvoiceId,
          imageUrl: photo.imageUrl,
        })) || [];

      setUploadedFiles((prev) => ({
        ...prev,
        checkInFile: checkInPhotos,
        checkOutFile: checkOutPhotos,
        taskPhotos: taskPhotoData,
        invoiceReceipt: invoicePhotos,
        shopperBagImages: shopperBagPhotos
      }));

      if (response.data.reportHeader?.inspectionDateTime) {
        setDate(new Date(response.data.reportHeader.inspectionDateTime));
      }
      // if (response.data.reportHeader?.inspectionTime) {
      setInspectionTime(response.data.reportHeader.inspectionTime);
      // }

      const answersMap: Record<string, any> = {};
      const questionsoldmaxScore: Record<string, any> = {};

      await response.data.questions.forEach((category: any) => {
        category.questions?.forEach((question: any) => {
          const option = JSON.parse(question.qOptionJson || "[]");
          questionsoldmaxScore[question.questionId] =
          {
            oldMaxScore: question.oldMaxScore
          }

          answersMap[question.questionId] = {
            isImageValid: true,
            reportDtlId: question.reportDtlId,
            value: question.value,
            questionId: question.questionId,
            optionId: option.find((item) => item.value === question.value)?.optionId,
            score: question?.score != null ? question?.score % 1 === 0 ? parseInt(question?.score) : question?.score : null,
            comment: question.comment || "",
            isAnswered: Boolean(question.isAnswered),
            photoUrl: question.photoUrl || "",
            maxScore: question?.score == -1 ? 0 : question.maxScore
            // maxScore:  question.maxScore
          };

        });
      });

      setAnswers(answersMap);
      setoldmaxScore(questionsoldmaxScore)

      if (response.data.reportHeader) {
        setarchieveImages(JSON.parse(response.data.reportHeader.archieveImages) || []);
        setcheckOuttime(new Date(response.data.reportHeader.checkOutDateTime || ''));
        setcheckIntime(new Date(response.data.reportHeader.checkInDateTime || ''));
      }

      // // After a slight delay (to wait for all setStates), save fresh data to localStorage
      // setTimeout(() => {
      //   saveFormDataToLocalStorage();
      //   console.log("✅ Saved fresh API data to localStorage");
      // }, 100);
    } catch (error) {
      console.error("Error fetching visit times:", error);
    }
  };

  useEffect(() => {
    fetchData();

  }, [allocationId]); // Depend on allocationId so it refetches when it changes

  useEffect(() => {
    // if (reportDetails?.reportHeader?.inspectionDateTime) {
    //   setDate(new Date(reportDetails?.reportHeader?.inspectionDateTime));
    // }
    localStorage.setItem("currentStep", currentStep.toString());
    localStorage.setItem("ActiveTask", currentStep.toString());
  }, [reportDetails, currentStep]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        localStorage.removeItem("currentStep");
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const handleTextChange = (field: string, value: string) => {
    setTextInputs((prev) => {
      const updatedState = { ...prev, [field]: value };
      return updatedState;
    });
  };

  const handleAddOnQuestionChange = (field: string, value: string) => {
    setAddOnQuestions((prev) => {
      const updatedState = { ...prev, [field]: value };
      return updatedState;
    });
  };

  const handleAnswerChange = (questionId: any, value: any) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: {
        ...(prev[questionId] || {}), // existing values (if any)
        ...value, // override or add new values
      },
    }));
  };

  const handleCommentChange = (questionId: number, comment: string) => {
    setAnswers((prev) => ({
      ...prev,
      [`comment_${questionId}`]: comment,
    }));
  };

  const totalSteps = 3;

  const handleRatingChange = (service: string, value: number) => {
    setRatings((prev) => ({
      ...prev,
      [service]: value,
    }));
  };
  // const uploadtaskphotos = async (data: any) => {
  //   try {
  //     const finaldata = {reportHeaderId:reportDetails?.reportHeader.reportHeaderId,taskPhotos:[data]}
  //     const res = await ApiScoreCardStep3(finaldata, clientGroup)
  //   } catch (error) {

  //   }
  // }

  const updateQuestion = async (data: any) => {
    try {
      const res = await ApiUpdateReportQuestion(data, clientGroup)
    } catch (error: any) {
      console.log("Error ON Blur Save ", error.message)
    }
  }

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,
    questionId?: number,
    reportDetailId?: number
  ) => {
    if (!event.target.files || event.target.files.length === 0) return;

    const newFiles = Array.from(event.target.files);

    try {
      dispatch(showLoading())
      for (const file of newFiles) {
        let finalFile = file;
        const ext = file.name.split(".").pop()?.toLowerCase();

        /* =======================
           🔹 HEIC / HEIF CONVERSION
           ======================= */
        if (["heic", "heif"].includes(ext || "")) {
          try {
            const convertedBlob = await heic2any({
              blob: file,
              toType: "image/png",
            });

            finalFile = new File(
              [convertedBlob as Blob],
              file.name.replace(/\.(heic|heif)$/i, ".png"),
              { type: "image/png" }
            );
          } catch (err) {
            console.error("HEIC conversion failed", err);
            toast.error("HEIC image conversion failed");
            continue;
          }
        }
        if (finalFile.type.startsWith("image/")) {
          const options = {
            maxSizeMB: 0.5, // max size per image
            maxWidthOrHeight: 1920, // resize large images
            initialQuality: 0.7,
            useWebWorker: true,
          };
          try {
            const compressed = await imageCompression(finalFile, options);
            const baseName = finalFile.name.replace(/\.[^/.]+$/, "");

            finalFile = new File(
              [compressed],
              `${baseName}.png`,
              { type: "image/png" }
            );
            console.log(
              `Compressed ${finalFile.name}: ${(finalFile.size / 1024 / 1024).toFixed(
                2
              )}MB → ${(finalFile.size / 1024 / 1024).toFixed(2)}MB`
            );
          } catch (err) {
            console.warn("Image compression failed", err);
            toast.error("Invalid image format");
            continue;
          }
        }

        //   try {
        //     const compressedFile = await imageCompression(finalFile, options);
        //     const fileNameWithoutExt = file.name.substring(0, file.name.lastIndexOf('.'));
        //     finalFile = new File([compressedFile], `${fileNameWithoutExt}.png`, { type: "image/png" });
        //     console.log(
        //       `Compressed ${file.name}: ${(file.size / 1024 / 1024).toFixed(
        //         2
        //       )}MB → ${(finalFile.size / 1024 / 1024).toFixed(2)}MB`
        //     );
        //   } catch (compressionError) {
        //     console.warn("Image compression failed, using original file:", compressionError);
        //     toast.error("Something went wrong. please try with proper image formate")
        //     continue
        //   }
        // }

        const formData = new FormData();
        formData.append("file", finalFile);

        if (fileTypeMap[section]) {
          formData.append("fileType", fileTypeMap[section]);
        }
        formData.append(
          "reportHeaderId",
          reportDetails?.reportHeader.reportHeaderId
        );
        if (section === "questionFiles" && questionId !== undefined) {
          formData.append("reportDtlId", reportDetailId?.toString() || "");
        }
        // Call API for each file
        const response = await CustomUploadProfilePic(formData);

        toast.success("File uploaded successfully");

        // Extract reportHdrImageId from response, update based on your actual API response shape
        const uploadedUrl = response.location;
        const newImageId = `${reportDetails?.reportHeader.reportHeaderId}${Date.now()}`; // Make sure this exists in your response


        // Update state with new uploaded file
        setUploadedFiles((prevState: any) => {
          if (section === "questionFiles" && questionId !== undefined) {
            const existingFiles = prevState.questionFiles[questionId] || [];
            const updatedFiles = [...existingFiles, uploadedUrl];

            setAnswers((prev) => {
              const existingAnswer = prev[questionId] || {};
              return {
                ...prev,
                [questionId]: {
                  ...existingAnswer,
                  photoUrl: updatedFiles.join(","),
                  reportDtlId: reportDetailId || existingAnswer.reportDtlId,
                },
              };

            });

            const updateddata = {
              reportHeaderId: reportDetails?.reportHeader?.reportHeaderId,
              platform: "web",
              platformAppType: null,
              reportDtlId: reportDetailId || answers[questionId]?.reportDtlId,
              value: answers[questionId]?.value,
              score: answers[questionId]?.score,
              comment: answers[questionId]?.comment,
              isAnswered: answers[questionId]?.isAnswered,
              maxScore: answers[questionId]?.maxScore,
              photoUrl: updatedFiles.join(","),
            };

            updateQuestion(updateddata)
            return {
              ...prevState,
              questionFiles: {
                ...prevState.questionFiles,
                [questionId]: updatedFiles,
              },
            };
          }

          // ✅ Corrected section for taskPhotos
          if (section === "taskPhotos") {



            const reorderedPhotos = (prevState.taskPhotos || [])
              .sort((a: any, b: any) => (a.displayOrder || 0) - (b.displayOrder || 0))
              .map((photo: any, index: number) => ({
                ...photo,
                displayOrder: index + 1 // Reset display order sequentially (1, 2, 3...)
              }));

            const updatedTaskPhotos = [
              ...(reorderedPhotos || []),
              {
                reportHdrImageId: newImageId,
                imageUrl: uploadedUrl,
                displayOrder: prevState?.taskPhotos?.length + 1
              },
            ];

            return {
              ...prevState,
              taskPhotos: updatedTaskPhotos,
            };
          }

          if (section === "invoiceReceipt") {
            const updatedinvoiceReceipt = [
              ...(prevState.invoiceReceipt || []),
              {
                reportHdrInvoiceId: newImageId,
                imageUrl: uploadedUrl,
              },
            ];

            return {
              ...prevState,
              invoiceReceipt: updatedinvoiceReceipt,
            };
          }

          // For others that use string URLs
          return {
            ...prevState,
            [section]: [...(prevState[section] || []), uploadedUrl],
          };
        });
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error("Error uploading file");
    }
    finally {
      dispatch(hideLoading())
    }
  };
  const handleFileUpdate = async (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,
    index: number,
    questionId?: number,
    reportDetailId?: number
  ) => {
    if (!event.target.files || event.target.files.length === 0) return;

    const file = event.target.files[0]; // updating one file at a time

    try {
      // Step 1️⃣: Remove the existing image before uploading the new one
      const existingItem =
        section === "taskPhotos"
          ? uploadedFiles?.taskPhotos?.[index]
          : section === "invoiceReceipt"
            ? uploadedFiles?.invoiceReceipt?.[index]
            : null;

      if (existingItem) {
        // Extract appropriate IDs
        const reportId =
          section === "taskPhotos"
            ? existingItem.reportHdrImageId
            : existingItem.reportHdrInvoiceId;

        // Await deletion before proceeding
        await handleRemoveFile(section, reportId, existingItem.imageUrl);
      }

      let finalFile = file;

      // ✅ Compress if image
      if (file.type.startsWith("image/")) {
        const options = {
          maxSizeMB: 1, // max size per image
          maxWidthOrHeight: 1920, // resize large images
          useWebWorker: true,
        };

        try {
          const compressedFile = await imageCompression(file, options);
          finalFile = new File([compressedFile], file.name, { type: file.type });
          console.log(
            `Compressed ${file.name}: ${(file.size / 1024 / 1024).toFixed(
              2
            )}MB → ${(finalFile.size / 1024 / 1024).toFixed(2)}MB`
          );
        } catch (compressionError) {
          console.warn("Image compression failed, using original file:", compressionError);
        }
      }

      // Step 2️⃣: Prepare FormData for upload
      const formData = new FormData();
      formData.append("file", finalFile);

      if (fileTypeMap[section]) {
        formData.append("fileType", fileTypeMap[section]);
      }
      formData.append(
        "reportHeaderId",
        reportDetails?.reportHeader.reportHeaderId
      );
      if (section === "questionFiles" && questionId !== undefined) {
        formData.append("reportDtlId", reportDetailId?.toString() || "");
      }

      // Step 3️⃣: Upload new file
      const response = await CustomUploadProfilePic(formData);
      const updatedUrl = response.location;

      toast.success("File updated successfully");

      // Step 4️⃣: Update state with new image
      const newImageId = `${reportDetails?.reportHeader.reportHeaderId}${Date.now()}`;

      setUploadedFiles((prevState: any) => {
        if (section === "taskPhotos") {
          const updatedTaskPhotos = [...(prevState.taskPhotos || [])];
          updatedTaskPhotos[index] = {
            reportHdrImageId: newImageId,
            imageUrl: updatedUrl,
            displayOrder: updatedTaskPhotos[index].displayOrder
          };
          return { ...prevState, taskPhotos: updatedTaskPhotos };
        }

        if (section === "invoiceReceipt") {
          const updatedInvoice = [...(prevState.invoiceReceipt || [])];
          updatedInvoice[index] = {
            reportHdrInvoiceId: newImageId,
            imageUrl: updatedUrl,
          };
          return { ...prevState, invoiceReceipt: updatedInvoice };
        }

        if (section === "questionFiles" && questionId !== undefined) {
          const existingFiles = prevState.questionFiles[questionId] || [];
          const updatedFiles = [...existingFiles];
          updatedFiles[index] = updatedUrl;

          setAnswers((prev) => {
            const existingAnswer = prev[questionId] || {};
            return {
              ...prev,
              [questionId]: {
                ...existingAnswer,
                photoUrl: updatedFiles.join(","),
                reportDtlId: reportDetailId || existingAnswer.reportDtlId,
              },
            };
          });
          const updateddata = {
            reportHeaderId: reportDetails?.reportHeader?.reportHeaderId,
            platform: "web",
            platformAppType: null,
            reportDtlId: reportDetailId || answers[questionId]?.reportDtlId,
            value: answers[questionId]?.value,
            score: answers[questionId]?.score,
            comment: answers[questionId]?.comment,
            isAnswered: answers[questionId]?.isAnswered,
            maxScore: answers[questionId]?.maxScore,
            photoUrl: updatedFiles.join(","),
          };

          // ✅ LOG OUTSIDE setState
          updateQuestion(updateddata)

          return {
            ...prevState,
            questionFiles: {
              ...prevState.questionFiles,
              [questionId]: updatedFiles,
            },
          };
        }

        // fallback for other sections
        const updatedSectionFiles = [...(prevState[section] || [])];
        updatedSectionFiles[index] = updatedUrl;
        return { ...prevState, [section]: updatedSectionFiles };
      });
    } catch (error) {
      console.error("Error updating file:", error);
      toast.error("Error updating file");
    }
  };

  // const moveinvoicetotaskphotos = async (imgUrl: string) => {
  //   try {
  //     setUploadedFiles((prevState: any) => {
  //       const newImageId = `${reportDetails?.reportHeader.reportHeaderId}${Date.now()}`;

  //       const updatedTaskPhotos = [
  //         ...(prevState.taskPhotos || []),
  //         {
  //           reportHdrImageId: newImageId,
  //           imageUrl: imgUrl,
  //           displayOrder: (prevState.taskPhotos?.length || 0) + 1,
  //         },
  //       ];

  //       return {
  //         ...prevState,
  //         taskPhotos: updatedTaskPhotos,
  //       };
  //     });

  //   } catch (error) {
  //     console.log('Error', error)
  //   }
  // }

  const moveinvoicetotaskphotos = async (imgUrl: string) => {
    try {
      setUploadedFiles((prevState: any) => {
        // First, reorder existing photos and fix their display order sequentially
        const reorderedPhotos = (prevState.taskPhotos || [])
          .sort((a: any, b: any) => (a.displayOrder || 0) - (b.displayOrder || 0))
          .map((photo: any, index: any) => ({
            ...photo,
            displayOrder: index + 1 // Reset display order sequentially (1, 2, 3...)
          }));

        // Calculate the next display order for the new photo
        const nextDisplayOrder = reorderedPhotos.length + 1;

        // Create new photo object
        const newImageId = `${reportDetails?.reportHeader.reportHeaderId}${Date.now()}`;
        const newPhoto = {
          reportHdrImageId: newImageId,
          imageUrl: imgUrl,
          displayOrder: nextDisplayOrder,
        };

        // Combine reordered photos with new photo
        const updatedTaskPhotos = [...reorderedPhotos, newPhoto];

        return {
          ...prevState,
          taskPhotos: updatedTaskPhotos,
        };
      });

    } catch (error) {
      console.log('Error', error);
    }
  };


  const handleRemoveFile = async (
    section: string,
    reportId: number, // This is reportHdrImageId or reportHdrInvoiceId
    imageUrl?: string,
    questionId?: number
  ) => {
    let payload: any = {};

    if (section === "taskPhotos") {
      payload = {
        type: "task_photos",
        reportHdrImageId: reportId,
        platform: "web",
        platformAppType: null
      };
    } else if (section === "invoiceReceipt") {
      payload = {
        type: "invoice",
        reportHdrInvoiceId: reportId,
        platform: "web",
        platformAppType: null
      };
    }

    try {
      if (section === "taskPhotos" || section === "invoiceReceipt") {
        if (typeof reportId === "number") {
          await ApiDeleteReportPhotos(payload, clientGroup);
        }
        // else{
        //   const updatedTaskPhotos = uploadedFiles?.section?.filter((item:any)=>item?.reportHdrImageId !== reportId)
        //   setUploadedFiles((prev)=>...prev)
        // }
        toast.success("File removed successfully!");

      }

      // Update uploadedFiles
      setUploadedFiles((prev) => {
        const updated = { ...prev };

        // Handle questionFiles separately
        if (section === "questionFiles" && questionId !== undefined) {
          const updatedFiles =
            prev.questionFiles[questionId]?.filter(
              (file: string) => file !== imageUrl
            ) || [];

          // Update the answers state with the new photoUrl string
          setAnswers((prev) => ({
            ...prev,
            [questionId]: {
              ...prev[questionId],
              photoUrl: updatedFiles.length > 0 ? updatedFiles.join(",") : "", // Join back to comma-separated string
            },
          }));
          const updateddata = {
            reportHeaderId: reportDetails?.reportHeader?.reportHeaderId,
            platform: "web",
            platformAppType: null,
            reportDtlId: answers[questionId]?.reportDtlId,
            value: answers[questionId]?.value,
            score: answers[questionId]?.score,
            comment: answers[questionId]?.comment,
            isAnswered: answers[questionId]?.isAnswered,
            maxScore: answers[questionId]?.maxScore,
            photoUrl: updatedFiles.join(","),
          };

          updateQuestion(updateddata)

          // Return the updated uploadedFiles state
          return {
            ...prev,
            questionFiles: {
              ...prev.questionFiles,
              [questionId]: updatedFiles,
            },
          };
        } else if (section === "taskPhotos") {
          updated[section] = prev[section]?.filter(
            (file: any) => file !== imageUrl
          );
        } else if (section === "invoiceReceipt") {
          updated[section] = prev[section]?.filter(
            (file: any) => file !== imageUrl
          );
        } else if (section === "checkInFile" || section === "checkOutFile" || section === "shopperBagImages") {
          updated[section] = prev[section]?.filter(
            (file: string) => file !== imageUrl
          );
        }

        return updated;
      });
    } catch (error: any) {
      toast.error("Failed to remove file.");
      console.error("File removal failed:", error);
    }
  };

  const handleNextCategory = async () => {
    if (reportDetails) {
      const questionAnswers = {
        reportHdrId: reportDetails?.reportHeader.reportHeaderId,
        platform: "web",
        platformAppType: null,
        archieveImages: selectedMoveImages?.length > 0 ? JSON.stringify([...archieveImages, ...selectedMoveImages]) : JSON.stringify(archieveImages),
        questions: Object.values(answers),
      };
      if (questionAnswers.questions.length > 0) {
        try {
          const responseStep2 = await ApiScoreCardStep2(
            questionAnswers,
            clientGroup
          );
          toast.success("Report saved successfully");
        } catch (error) {
          console.error("Error saving category data:", error);
          toast.error("Failed to save category data");
          return; // Don't proceed if save fails
        }
      }

      if (currentCategoryIndex < reportDetails.questions.length - 1) {
        setCurrentCategoryIndex(currentCategoryIndex + 1);
        // Clear validation errors when moving to next category
        setValidationErrors([]);
        setShowValidationErrors(false);
      } else {
        // If we're at the last category, move to the next step
        setCurrentStep(currentStep + 1);
        setCurrentCategoryIndex(0); // Reset category index for next time
      }
    }
  };

  const submitStep2 = async () => {
    if (reportDetails) {
      const questionAnswers = {
        reportHdrId: reportDetails?.reportHeader.reportHeaderId,
        platform: "web",
        platformAppType: null,
        archieveImages: selectedMoveImages?.length > 0 ? JSON.stringify([...archieveImages, ...selectedMoveImages]) : JSON.stringify(archieveImages),
        questions: Object.values(answers),
      };
      const storedData = localStorage.getItem("ScoreCardStep1");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        parsedData.teamMemberDescription = staffMemberDesc;
        localStorage.setItem("ScoreCardStep1", JSON.stringify(parsedData));
      }

      if (questionAnswers.questions.length > 0) {
        try {
          const responseStep2 = await ApiScoreCardStep2(
            questionAnswers,
            clientGroup
          );
          toast.success("Report saved successfully");
          localStorage.setItem("ScoreCardStep2", JSON.stringify(questionAnswers));
        } catch (error) {
          console.error("Error saving category data:", error);
          toast.error("Failed to save category data");
          return; // Don't proceed if save fails
        }

      }

      // if (currentCategoryIndex < reportDetails.questions.length - 1) {
      //   setCurrentCategoryIndex(currentCategoryIndex + 1);
      //   // Clear validation errors when moving to next category
      //   setValidationErrors([]);
      //   setShowValidationErrors(false);
      // } 
      // else {
      //   setCurrentStep(currentStep + 1);
      //   setCurrentCategoryIndex(0); 
      // }
      setCurrentStep(currentStep + 1);
    }
  }
  const submitStep1 = async () => {
    const formattedRatings = Object.entries(ratings).map(([id, score]) => ({
      reportStarRatingId: Number(id),
      starRatingScore: score,
    }));

    const formattedBriefJson = Object.entries(textInputs)
      .filter(([key, answer]) => {
        if (key === "teamMemberDescription") return false;

        // Admin: include all fields
        if (isAdmin) return true;

        // Non-admin: include only filled fields
        return String(answer).trim() !== "";
      })
      .map(([id, answer]) => ({
        reportBriefJsonId: Number(id),
        briefJsonAnswer: answer,
      }));

    const formattedAddOnquestions = Object.entries(addOnQuestions).map(
      ([id, answer]) => ({
        reportAddOnQuestionId: Number(id),
        addOnQuestionValue: answer,
      })
    );

    const inputDate = new Date(date);
    const formattedDate =
      inputDate.toLocaleString("sv-SE").replace("T", " ").slice(0, -1);
    const inputDate2 = new Date(checkIntime);
    const formattedDate2 =
      inputDate2.toLocaleString("sv-SE").replace("T", " ").padStart(3, '0');

    const result = {
      reportHeaderId: reportDetails?.reportHeader.reportHeaderId,
      platform: "web",
      platformAppType: null,
      starRating: formattedRatings,
      scoreCard: {
        inspectionDateTime: formattedDate,
        inspectionTime: inspectiontime,
      },
      ...(uploadedFiles.checkInFile?.join(", ") && formattedDate2 && {
        locationDetails: {
          checkInDateTime: formattedDate2,
          checkInPhotoUrl: uploadedFiles.checkInFile?.join(", ")
        },
      }),
      // teamMemberDescription: staffMemberDesc,
      ...(isAdmin || String(staffMemberDesc).trim() !== ""
        ? { teamMemberDescription: staffMemberDesc }
        : {}),
      ...(clientGroup === "BLOOMS" &&
        // additionalNoteForShopper: additionalNoteForShopper
        (isAdmin || String(additionalNoteForShopper).trim() !== "")
        ? { additionalNoteForShopper }
        : {}
      ),

      briefJson: formattedBriefJson,
      addOnQuestions: formattedAddOnquestions,
    };

    localStorage.setItem("ScoreCardStep1", JSON.stringify(result));

    try {
      if (result) {
        await ApiScoreCardStep1(result, clientGroup);
        toast.success("Report saved successfully")
      }
    } catch (error) {
      console.error("Step 1 API failed:", error);
    }
  }

  const handleNextCategory2 = async () => {
    // console.log("Outside Firts completed")
    submitStep2()

  };

  const handlePreviousCategory = () => {
    if (currentCategoryIndex > 0) {
      setCurrentCategoryIndex(currentCategoryIndex - 1);
    } else {
      setCurrentStep(currentStep - 1);
      setCurrentCategoryIndex(0); // Reset category index for next time
    }
  };
  // Update the handleNextStep function to handle category navigation in Step 2
  const handleNextStep = async () => {
    // Reset validation state
    setValidationErrors([]);
    setShowValidationErrors(false);

    // If we're in Step 2 (QuestionsBank), handle category navigation
    // if (currentStep === 2 && reportDetails?.reportHeader?.allocationClientGroup !== 'ALDI' && reportDetails?.reportHeader?.allocationClientGroup !== 'TRANSPORT') {
    //   await handleNextCategory(); // This will handle saving and navigation
    //   return;
    // }
    // if (currentStep === 2 && reportDetails?.reportHeader?.allocationClientGroup === 'ALDI' || reportDetails?.reportHeader?.allocationClientGroup === 'TRANSPORT') {
    //   await handleNextCategory2(); // This will handle saving and navigation
    //   return;
    // }
    if (currentStep === 2) {
      await handleNextCategory2(); // This will handle saving and navigation
      return;
    }

    // For other steps, proceed with normal step validation and navigation
    let validationResult = { isValid: true, errors: [] };
    if (currentStep === 1) {
      submitStep1()
    } else if (currentStep === 3) {
      validationResult = validateStep3(invoice, uploadedFiles, reportDetails, checkIntime);

      if (validationResult.isValid) {
        const inputDate = new Date(checkOuttime);
        const formattedDate =
          inputDate.toLocaleString("sv-SE").replace("T", " ");
        const data = {
          reportHeaderId: reportDetails?.reportHeader.reportHeaderId,
          taskPhotos: uploadedFiles.taskPhotos,
          platform: "web",
          platformAppType: null,
          invoice: {
            spentFoodAmt: invoice.food,
            spentBarAmt: invoice.bar,
            spentGamingAmt: invoice.total,
          },
          invoicePhotos: uploadedFiles.invoiceReceipt,
          ...(formattedDate && uploadedFiles.checkOutFile.join(", ") && {
            locationDetails: {
              checkOutPhotoUrl: uploadedFiles.checkOutFile.join(", "),
              checkOutDateTime: formattedDate,
            },
          }),
          ...(reportDetails?.reportHeader?.allocationClientGroup === "ALDI" && {
            shopperBagImages: uploadedFiles.shopperBagImages.join(","),
          }),
        };

        try {
          await ApiScoreCardStep3(data, clientGroup); // Assuming this API call exists for step 3
          toast.success("Report saved successfully")
        } catch (error) {
          console.error("Step 3 API failed:", error);
        }
      }
    }

    // If validation fails, show errors and prevent moving to next step
    if (!validationResult.isValid) {
      setValidationErrors(validationResult.errors);
      setShowValidationErrors(true);
      return;
    }

    // If validation passes, proceed to next step
    if (currentStep < totalSteps) {
      const nextStep = currentStep + 1;
      setCurrentStep(nextStep);
      localStorage.setItem("currentStep", nextStep.toString());
    }
  };

  // Update the handlePreviousStep function to handle category navigation in Step 2
  const handlePreviousStep = () => {
    // If we're in Step 2 (QuestionsBank), handle category navigation
    if (currentStep === 2) {
      handlePreviousCategory(); // This will handle navigation between categories or to previous step
      return;
    }

    // For other steps, proceed with normal step navigation
    const nextStep = currentStep - 1;
    setCurrentStep(nextStep);
    setValidationErrors([]);
    setShowValidationErrors(false);
  };

  const handleSyncDataToServer = async () => {
    const formattedRatings = Object.entries(ratings).map(([id, score]) => ({
      reportStarRatingId: Number(id), // Convert string key to number
      starRatingScore: score,
    }));
    const formattedBriefJson = Object.entries(textInputs)
      .filter(([key, answer]) => {
        if (key === "teamMemberDescription") return false;

        // Admin: include all fields
        if (isAdmin) return true;

        // Non-admin: include only filled fields
        return String(answer).trim() !== "";
      }) // Exclude "teamMemberDescription"
      .map(([id, answer]) => ({
        reportBriefJsonId: Number(id), // Convert key to number
        briefJsonAnswer: answer,
      }));

    const formattedAddOnquestions = Object.entries(addOnQuestions).map(
      ([id, answer]) => ({
        reportAddOnQuestionId: Number(id),
        addOnQuestionValue: answer,
      })
    );
    const inputDate = new Date(date);
    const formattedDate =
      // inputDate.toLocaleString("sv-SE").replace("T", " ").slice(0, -1);
      inputDate
        ? `${String(inputDate.getDate()).padStart(2, "0")}/${String(inputDate.getMonth() + 1).padStart(2, "0")
        }/${inputDate.getFullYear()}`
        : "";

    const inputDate2 = new Date(checkOuttime);
    const checkInDate = new Date(checkIntime);
    const formattedDate2 =
      inputDate2.toLocaleString("sv-SE").replace("T", " ");
    const formattedcheckinDate =
      checkInDate.toLocaleString("sv-SE").replace("T", " ");
    const result = {
      reportHeaderId: reportDetails?.reportHeader.reportHeaderId,
      platform: "web",
      platformAppType: null,
      starRating: formattedRatings,
      scoreCard: {
        inspectionDateTime: formattedDate,
        inspectionTime: inspectiontime
      },
      // teamMemberDescription: staffMemberDesc, // Separate extracted value
      ...(isAdmin || String(staffMemberDesc).trim() !== ""
        ? { teamMemberDescription: staffMemberDesc }
        : {}),
      ...(clientGroup === "BLOOMS" &&
        // additionalNoteForShopper: additionalNoteForShopper
        (isAdmin || String(additionalNoteForShopper).trim() !== "")
        ? { additionalNoteForShopper }
        : {}),

      briefJson: formattedBriefJson,
      addOnQuestions: formattedAddOnquestions,
      ...(uploadedFiles?.uploadedFiles?.checkInFile?.join(", ") && formattedcheckinDate && {
        locationDetails: {
          checkInDateTime: formattedcheckinDate,
          checkInPhotoUrl: uploadedFiles?.checkInFile?.join(", ")
        }
      })
    };

    if (result) {
      const responseStep1 = await ApiScoreCardStep1(result, clientGroup);
    }

    const questionAnswers = {
      reportHdrId: reportDetails?.reportHeader.reportHeaderId,
      platform: "web",
      platformAppType: null,
      archieveImages: selectedMoveImages?.length > 0 ? JSON.stringify([...archieveImages, ...selectedMoveImages]) : JSON.stringify(archieveImages),
      questions: Object.values(answers),
    };
    if (questionAnswers.questions.length > 0) {
      const responseStep2 = await ApiScoreCardStep2(
        questionAnswers,
        clientGroup
      );
    }

    const data = {
      isNeedToConfirm: false,
      reportHeaderId: reportDetails?.reportHeader.reportHeaderId,
      platform: "web",
      platformAppType: null,
      // taskPhotos: uploadedFiles.taskPhotos.filter(
      //   (item: any) => typeof item === "string"
      // ),
      // taskPhotos: uploadedFiles.taskPhotos
      //   ?.filter((item: any) => {
      //     if (typeof item !== "object" || item.reportHdrImageId == null) return false;

      //     const alreadyExists = reportDetails?.taskPhotos?.some(
      //       (existing: any) => existing.reportHdrImageId === item.reportHdrImageId
      //     );

      //     return !alreadyExists;
      //   })
      //   .map((item: any) => item.imageUrl),
      taskPhotos: uploadedFiles.taskPhotos
        ?.filter((item: any) => typeof item === "object" && item.reportHdrImageId != null)
        .map((item: any, index: number) => ({
          img: item.imageUrl,
          displayOrder: item?.displayOrde ?? index + 1
        })),
      invoiceDetails: {
        spentFoodAmt: invoice.food,
        spentBarAmt: invoice.bar,
        spentGamingAmt: invoice.gaming,
        spentBottleShopAmt: invoice.bottleshop,
        totalSpentAmt: invoice.total,
      },
      // invoicePhotos: uploadedFiles.invoicePhotos.filter(
      //   (item: any) => typeof item === "string"
      // ),
      invoicePhotos: uploadedFiles.invoiceReceipt
        ?.filter((item: any) => {
          if (typeof item !== "object" || item.reportHdrImageId == null) return false;

          const alreadyExists = reportDetails?.invoicePhotos?.some(
            (existing: any) => existing.reportHdrImageId === item.reportHdrImageId
          );

          return !alreadyExists;
        })
        .map((item: any) => item.imageUrl),
      // locationDetails: {
      //   checkInPhotoUrl: uploadedFiles.checkInFile.join(", "),
      //   checkOutPhotoUrl: uploadedFiles.checkOutFile.join(", "),
      // },
      ...(formattedDate2 && uploadedFiles?.checkOutFile?.join(", ") && {
        locationDetails: {
          checkOutPhotoUrl: uploadedFiles?.checkOutFile?.join(", "),
          checkOutDateTime: formattedDate2,
        },
      }),
      ...(reportDetails?.reportHeader?.allocationClientGroup === "ALDI" && {
        shopperBagImages: uploadedFiles.shopperBagImages.join(","),
      }),
    };
    if (data) {
      const responseStep3 = await ApiScoreCardStep3(data, clientGroup);
    }
    toast.success("Your report was successfully synced.");
    localStorage.removeItem(`isScoreCardEdited_${allocationId}`);
    //navigate("/dashboard/mytask");
  };

  // reorderFiles.ts

  // Generic reorder utility
  const reorderArray = (list: any[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  // Main function for your uploaded files state
  const reorderFiles = (
    // setUploadedFiles: Function,
    // setAnswers: Function,
    section: string,
    sourceIndex: number,
    destinationIndex: number,
    questionId?: string | number
  ) => {
    setUploadedFiles((prevState: any) => {
      if (section === "questionFiles" && questionId !== undefined) {
        const existingFiles = prevState.questionFiles[questionId] || [];
        const reorderedFiles = reorderArray(existingFiles, sourceIndex, destinationIndex);

        // also update answers
        setAnswers((prev: any) => {
          const existingAnswer = prev[questionId] || {};
          return {
            ...prev,
            [questionId]: {
              ...existingAnswer,
              photoUrl: reorderedFiles.join(","), // keep CSV string
              reportDtlId: existingAnswer.reportDtlId,
            },
          };
        });
        const updateddata = {
          reportHeaderId: reportDetails?.reportHeader?.reportHeaderId,
          platform: "web",
          platformAppType: null,
          reportDtlId: answers[questionId]?.reportDtlId,
          value: answers[questionId]?.value,
          score: answers[questionId]?.score,
          comment: answers[questionId]?.comment,
          isAnswered: answers[questionId]?.isAnswered,
          maxScore: answers[questionId]?.maxScore,
          photoUrl: reorderedFiles.join(","),
        };

        updateQuestion(updateddata)


        return {
          ...prevState,
          questionFiles: {
            ...prevState.questionFiles,
            [questionId]: reorderedFiles,
          },
        };
      }

      if (section === "taskPhotos") {
        const reorderedTaskPhotos = reorderArray(prevState.taskPhotos || [], sourceIndex, destinationIndex);
        return {
          ...prevState,
          taskPhotos: reorderedTaskPhotos,
        };
      }

      if (section === "invoiceReceipt") {
        const reorderedInvoiceReceipt = reorderArray(prevState.invoiceReceipt || [], sourceIndex, destinationIndex);
        return {
          ...prevState,
          invoiceReceipt: reorderedInvoiceReceipt,
        };
      }

      // default: string array sections
      const reorderedGeneric = reorderArray(prevState[section] || [], sourceIndex, destinationIndex);
      return {
        ...prevState,
        [section]: reorderedGeneric,
      };
    });
  };



  const handleSubmit = async (isClose: boolean = false) => {
    const validationResult = { isValid: true, errors: [] };
    // Step 1
    const step1Result = validateStep1(
      reportDetails,
      clientGroup,
      date,
      inspectiontime,
      ratings,
      reportDetails?.starRatingResponseData || [],
      staffMemberDesc,
      additionalNoteForShopper,
      textInputs,
      addOnQuestions,
      reportDetails?.briefJsonDataResponse || [],
      reportDetails?.addOnQuestion || [],
      uploadedFiles,
      checkIntime,
      npsData
    );

    // Step 2
    const allCategoriesValidation = [];
    let step2HasErrors = false;
    let errorCategoryIndex = -1;

    // if (reportDetails && reportDetails?.reportHeader?.allocationClientGroup !== "ALDI" && reportDetails?.reportHeader?.allocationClientGroup !== "TRANSPORT") {
    //   for (let i = 0; i < reportDetails?.questions.length; i++) {
    //     const categoryValidation = validateStep2(answers, reportDetails, i);
    //     if (!categoryValidation.isValid) {
    //       step2HasErrors = true;
    //       if (errorCategoryIndex === -1) {
    //         errorCategoryIndex = i; // Store the first category with errors
    //       }
    //       allCategoriesValidation.push(...(categoryValidation.errors || []));
    //     }
    //   }
    // }

    // else {
    if (reportDetails) {
      // Flatten all questions with category info, deduplicate, and sort by displayOrder
      const orderedQuestions = Array.from(
        new Map(
          reportDetails.questions
            .flatMap((category: any) =>
              category.questions.map((q: any) => ({
                ...q,
                categoryName: category.categoryName,
              }))
            )
            .map((q: any) => [q.questionId, q]) // deduplicate by questionId
        ).values()
      )
        .filter((q: any) => q.displayOrder !== undefined)
        .sort((a: any, b: any) => a.displayOrder - b.displayOrder);

      for (let i = 0; i < orderedQuestions.length; i++) {
        const question: any = orderedQuestions[i];

        // Find the category index for this question
        const categoryIndex = reportDetails.questions.findIndex(
          (cat: any) => cat.categoryName === question.categoryName
        );

        const categoryValidation = AldivalidateStep2(answers, reportDetails);

        if (!categoryValidation.isValid) {
          step2HasErrors = true;
          if (errorCategoryIndex === -1) {
            errorCategoryIndex = categoryIndex; // store first category with errors
          }
          allCategoriesValidation.push(...(categoryValidation.errors || []));
        }
      }
    }

    // }

    // Step 3
    const step3Result = validateStep3(invoice, uploadedFiles, reportDetails, checkOuttime, checkIntime);
    // Check which step has errors and navigate to it
    const inputDate = new Date(checkOuttime);
    const formattedDate =
      checkOuttime ? inputDate?.toLocaleString("sv-SE")?.replace("T", " ") : '';
    const data = {
      isNeedToConfirm: false,
      reportHeaderId: reportDetails?.reportHeader.reportHeaderId,
      platform: "web",
      platformAppType: null,
      // taskPhotos: uploadedFiles.taskPhotos.filter(
      //   (item: any) => typeof item === "string"
      // ),
      // taskPhotos: uploadedFiles.taskPhotos
      //   ?.filter((item: any) => {
      //     if (typeof item !== "object" || item.reportHdrImageId == null) return false;

      //     // const alreadyExists = reportDetails?.taskPhotos?.some(
      //     //   (existing: any) => existing.reportHdrImageId === item.reportHdrImageId
      //     // );

      //     // return !alreadyExists;
      //   })
      //   .map((item: any, index:number) => 
      //     ({"img": item.imageUrl,
      //     "displayOrder": item?.displayOrder ?? index + 1})
      //   ),
      taskPhotos: uploadedFiles.taskPhotos
        ?.filter((item: any) => typeof item === "object" && item.reportHdrImageId != null)
        .map((item: any, index: number) => ({
          img: item.imageUrl,
          displayOrder: item?.displayOrde ?? index + 1
        })),

      invoiceDetails: {
        spentFoodAmt: invoice.food,
        spentBarAmt: invoice.bar,
        spentGamingAmt: invoice.gaming,
        totalSpentAmt: invoice.total,
      },
      // archieveImages: archieveImages,
      // invoicePhotos: uploadedFiles.invoiceReceipt.filter(
      //   (item: any) => typeof item === "string"
      // ),
      invoicePhotos: uploadedFiles.invoiceReceipt
        ?.filter((item: any) => {
          if (typeof item !== "object" || item.reportHdrInvoiceId == null) return false;

          const alreadyExists = reportDetails?.invoicePhotos?.some(
            (existing: any) => existing.reportHdrInvoiceId === item.reportHdrInvoiceId
          );

          return !alreadyExists;
        })
        .map((item: any) => item.imageUrl),

      ...(formattedDate && uploadedFiles.checkOutFile?.join(", ") && {
        locationDetails: {
          checkOutPhotoUrl: uploadedFiles.checkOutFile?.join(", "),
          checkOutDateTime: formattedDate,
        }
      }),
      ...(reportDetails?.reportHeader?.allocationClientGroup === "ALDI" && {
        shopperBagImages: uploadedFiles.shopperBagImages?.join(","),
      }),
    };


    try {
      if ((localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor')) {
        await submitStep1()
        await submitStep2()
        localStorage.removeItem("ScoreCardStep1");
        localStorage.removeItem("ScoreCardStep2");
      }
      const storedData = localStorage.getItem("ScoreCardStep1");
      const resultObject = storedData ? JSON.parse(storedData) : null;

      const questionAnswerData = localStorage.getItem("ScoreCardStep2");
      const questionAnswerObject = questionAnswerData
        ? JSON.parse(questionAnswerData)
        : null;

      if (resultObject !== null) {
        const responseStep1 = await ApiScoreCardStep1(
          resultObject,
          clientGroup
        );
      }
      // localStorage.removeItem("ScoreCardStep1");
      if (questionAnswerObject && questionAnswerObject.questions.length > 0) {
        const responseStep2 = await ApiScoreCardStep2(
          questionAnswerObject,
          clientGroup
        );
        localStorage.removeItem("ScoreCardStep2");
      }
      const responseStep3 = await ApiScoreCardStep3(data, clientGroup);

      // if (!step1Result.isValid) {
      //   setValidationErrors(step1Result.errors);
      //   setShowValidationErrors(true);
      //   setCurrentStep(1); // Navigate to step 1
      //   return;
      // } else if (step2HasErrors) {
      //   setValidationErrors(allCategoriesValidation);
      //   setShowValidationErrors(true);
      //   setCurrentStep(2); // Navigate to step 2
      //   setCurrentCategoryIndex(errorCategoryIndex); // Navigate to the specific category with errors
      //   return;
      // } else if (!step3Result.isValid) {
      //   setValidationErrors(step3Result.errors);
      //   setShowValidationErrors(true);
      //   setCurrentStep(3); // Navigate to step 3
      //   return;
      // }
      validationResult.isValid = true;
      // Clear all localStorage data for this scorecard when successfully submitted
      localStorage.removeItem(`scorecard_${allocationId}`);
      localStorage.removeItem("scoreCardAnswers");
      localStorage.removeItem("scoreCardUploadedFiles");
      localStorage.removeItem("currentStep");
      localStorage.removeItem(`isScoreCardEdited_${allocationId}`);

      toast.success("Score card Saved successfully");
      if ((localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'clientadmin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor')) {
        if (isClose) {
          localStorage.removeItem("selectedVenue")
          window.close()
        }
      }
      else {
        if (isClose) {
          navigate("/dashboard/mytasks")
        }
      }
      //navigate("/dashboard/mytask");
    } catch (error) {
      console.error("Error submitting score card:", error);
      toast.error("Failed to submit score card. Please try again.");
    }

    // If no validation errors, proceed with submiss
    // await fetchData();

    // If no validation errors, show the preview
    // setShowPreview(true);
  };

  const handleFinalSubmit = async () => {

    const validationResult = { isValid: true, errors: [] };
    const step1Result = validateStep1(
      reportDetails,
      clientGroup,
      date,
      inspectiontime,
      ratings,
      reportDetails?.starRatingResponseData || [],
      staffMemberDesc,
      additionalNoteForShopper,
      textInputs,
      addOnQuestions,
      reportDetails?.briefJsonDataResponse || [],
      reportDetails?.addOnQuestion || [],
      uploadedFiles,
      checkIntime,
      npsData
    );


    // Step 2 Validation
    const allCategoriesValidation: any[] = [];
    let step2HasErrors = false;
    let errorCategoryIndex = -1;

    // if (
    //   reportDetails &&
    //   reportDetails?.reportHeader?.allocationClientGroup !== "ALDI" &&
    //   reportDetails?.reportHeader?.allocationClientGroup !== "TRANSPORT"
    // ) {
    //   for (let i = 0; i < reportDetails?.questions.length; i++) {
    //     const categoryValidation = validateStep2(answers, reportDetails, i);
    //     if (!categoryValidation.isValid) {
    //       step2HasErrors = true;
    //       if (errorCategoryIndex === -1) {
    //         errorCategoryIndex = i; // first category with errors
    //       }
    //       allCategoriesValidation.push(...(categoryValidation.errors || []));
    //     }
    //   }
    // } 
    if (reportDetails) {
      // ALDI/TRANSPORT custom validation
      const orderedQuestions = Array.from(
        new Map(
          reportDetails.questions
            .flatMap((category: any) =>
              category.questions.map((q: any) => ({
                ...q,
                categoryName: category.categoryName,
              }))
            )
            .map((q: any) => [q.questionId, q]) // deduplicate
        ).values()
      )
        .filter((q: any) => q.displayOrder !== undefined)
        .sort((a: any, b: any) => a.displayOrder - b.displayOrder);

      for (let i = 0; i < orderedQuestions.length; i++) {
        const question: any = orderedQuestions[i];
        const categoryIndex = reportDetails.questions.findIndex(
          (cat: any) => cat.categoryName === question.categoryName
        );

        const categoryValidation = AldivalidateStep2(answers, reportDetails);
        if (!categoryValidation.isValid) {
          step2HasErrors = true;
          if (errorCategoryIndex === -1) {
            errorCategoryIndex = categoryIndex;
          }
          allCategoriesValidation.push(...(categoryValidation.errors || []));
        }
      }
    }

    // Step 3 Validation
    const step3Result = validateStep3(
      invoice,
      uploadedFiles,
      reportDetails,
      checkOuttime,
      checkIntime
    );

    // ⛔ STOP here if validation failed
    if (!step1Result.isValid) {
      setValidationErrors(step1Result.errors);
      setShowValidationErrors(true);
      setCurrentStep(1);
      return;
    } else if (step2HasErrors) {
      setValidationErrors(allCategoriesValidation);
      setShowValidationErrors(true);
      setCurrentStep(2);
      setCurrentCategoryIndex(errorCategoryIndex);
      return;
    } else if (!step3Result.isValid) {
      setValidationErrors(step3Result.errors);
      setShowValidationErrors(true);
      setCurrentStep(3);
      return;
    }

    validationResult.isValid = true;
    const inputDate = new Date(checkOuttime);
    const formattedDate =
      inputDate.toLocaleString("sv-SE").replace("T", " ");

    const data = {
      reportHeaderId: reportDetails?.reportHeader.reportHeaderId,
      platform: "web",
      platformAppType: null,
      ...(localStorage.getItem("liveuserRole") === 'clientadmin' ? {
        editorToApproveReport: true,
      } : { isNeedToConfirm: true }),

      // taskPhotos: uploadedFiles.taskPhotos
      //   ?.filter((item: any) => {
      //     if (typeof item !== "object" || item.reportHdrImageId == null)
      //       return false;

      //     const alreadyExists = reportDetails?.taskPhotos?.some(
      //       (existing: any) => existing.reportHdrImageId === item.reportHdrImageId
      //     );

      //     return !alreadyExists;
      //   })
      //   .map((item: any) => item.imageUrl),

      taskPhotos: uploadedFiles.taskPhotos
        ?.filter((item: any) => typeof item === "object" && item.reportHdrImageId != null)
        .map((item: any, index: number) => ({
          img: item.imageUrl,
          displayOrder: item?.displayOrde ?? index + 1
        })),

      invoiceDetails: {
        spentFoodAmt: invoice.food,
        spentBarAmt: invoice.bar,
        spentGamingAmt: invoice.gaming,
        totalSpentAmt: invoice.total,
      },
      invoicePhotos: uploadedFiles.invoiceReceipt
        ?.filter((item: any) => {
          if (typeof item !== "object" || item.reportHdrInvoiceId == null)
            return false;

          const alreadyExists = reportDetails?.invoicePhotos?.some(
            (existing: any) => existing.reportHdrInvoiceId === item.reportHdrInvoiceId
          );

          return !alreadyExists;
        })
        .map((item: any) => item.imageUrl),

      locationDetails: {
        checkOutPhotoUrl: uploadedFiles.checkOutFile?.join(", "),
        checkOutDateTime: formattedDate,
      },
      ...(reportDetails?.reportHeader?.allocationClientGroup === "ALDI" && {
        shopperBagImages: uploadedFiles.shopperBagImages.join(","),
      }),
    };


    console.log("Invoice Photots", uploadedFiles.invoiceReceipt
      ?.filter((item: any) => {
        if (typeof item !== "object" || item.reportHdrInvoiceeId == null)
          return false;

        const alreadyExists = reportDetails?.invoicePhotos?.some(
          (existing: any) => existing.reportHdrInvoiceId === item.reportHdrInvoiceId
        );

        return !alreadyExists;
      })
      .map((item: any) => item.imageUrl))
    try {
      if (!isAdmin &&  !isreviewd && reportDetails?.allocationDetails?.clientEntityId?.isAISummaryRequired) {
        setOpenReviewRequired(true)
        // toast.info("Please review the report with ai before final submit")
        return
      }
      // ✅ Call APIs only after validation passed
      if ((localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor')) {
        await submitStep1()
        await submitStep2()
        localStorage.removeItem("ScoreCardStep1");
        localStorage.removeItem("ScoreCardStep2");
      }
      const storedData = localStorage.getItem("ScoreCardStep1");
      const resultObject = storedData ? JSON.parse(storedData) : null;

      const questionAnswerData = localStorage.getItem("ScoreCardStep2");
      const questionAnswerObject = questionAnswerData
        ? JSON.parse(questionAnswerData)
        : null;

      if (resultObject !== null) {
        await ApiScoreCardStep1(resultObject, clientGroup);
        localStorage.removeItem("ScoreCardStep1");
      }

      if (questionAnswerObject && questionAnswerObject.questions.length > 0) {
        await ApiScoreCardStep2(questionAnswerObject, clientGroup);
        localStorage.removeItem("ScoreCardStep2");
      }

      await ApiScoreCardStep3(data, clientGroup);

      // Clear storage
      localStorage.removeItem(`scorecard_${allocationId}`);
      localStorage.removeItem("scoreCardAnswers");
      localStorage.removeItem("scoreCardUploadedFiles");
      localStorage.removeItem("currentStep");
      localStorage.removeItem(`isScoreCardEdited_${allocationId}`);

      toast.success("Score card submitted successfully");
      if ((localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem('liveuserRole') === 'clientadmin' || localStorage.getItem("liveuserRole") === 'editor')) {
        localStorage.removeItem("selectedVenue")
        window.close()
      }
      else {
        navigate("/dashboard/mytasks")
      }
      // await fetchData();
    } catch (error) {
      console.error("Error submitting score card:", error);
      toast.error("Failed to submit score card. Please try again.");
    }
  };


  const downloadScorecard = async () => {
    try {
      const data = `?allocationId=${reportDetails?.reportHeader?.allocationId}`
      const res = await ApiDownloadScorecard(data, clientGroup)
      const blob = new Blob([res], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      // link.download = `Score_${shopperInvoiceId}.pdf`;
      link.download = `${reportDetails?.venueName}.pdf`;
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url)
      // setInvoiceList(res.data)
    } catch (error: any) {
      const message =
        error?.response?.data?.message || // API error message
        error?.message ||                 // JS error message
        String(error);
      toast.error(message)
    }

  }
  const downloadReport = async (isClose: boolean = false) => {
    const validationResult = { isValid: true, errors: [] };
    // Step 1
    const step1Result = validateStep1(
      reportDetails,
      clientGroup,
      date,
      inspectiontime,
      ratings,
      reportDetails?.starRatingResponseData || [],
      staffMemberDesc,
      additionalNoteForShopper,
      textInputs,
      addOnQuestions,
      reportDetails?.briefJsonDataResponse || [],
      reportDetails?.addOnQuestion || [],
      uploadedFiles,
      checkIntime,
      npsData
    );

    // Step 2
    const allCategoriesValidation = [];
    let step2HasErrors = false;
    let errorCategoryIndex = -1;

    // if (reportDetails && reportDetails?.reportHeader?.allocationClientGroup !== "ALDI" && reportDetails?.reportHeader?.allocationClientGroup !== "TRANSPORT") {
    //   for (let i = 0; i < reportDetails?.questions.length; i++) {
    //     const categoryValidation = validateStep2(answers, reportDetails, i);
    //     if (!categoryValidation.isValid) {
    //       step2HasErrors = true;
    //       if (errorCategoryIndex === -1) {
    //         errorCategoryIndex = i; // Store the first category with errors
    //       }
    //       allCategoriesValidation.push(...(categoryValidation.errors || []));
    //     }
    //   }
    // }

    // else {
    if (reportDetails) {
      // Flatten all questions with category info, deduplicate, and sort by displayOrder
      const orderedQuestions = Array.from(
        new Map(
          reportDetails.questions
            .flatMap((category: any) =>
              category.questions.map((q: any) => ({
                ...q,
                categoryName: category.categoryName,
              }))
            )
            .map((q: any) => [q.questionId, q]) // deduplicate by questionId
        ).values()
      )
        .filter((q: any) => q.displayOrder !== undefined)
        .sort((a: any, b: any) => a.displayOrder - b.displayOrder);

      for (let i = 0; i < orderedQuestions.length; i++) {
        const question: any = orderedQuestions[i];

        // Find the category index for this question
        const categoryIndex = reportDetails.questions.findIndex(
          (cat: any) => cat.categoryName === question.categoryName
        );

        const categoryValidation = AldivalidateStep2(answers, reportDetails);

        if (!categoryValidation.isValid) {
          step2HasErrors = true;
          if (errorCategoryIndex === -1) {
            errorCategoryIndex = categoryIndex; // store first category with errors
          }
          allCategoriesValidation.push(...(categoryValidation.errors || []));
        }
      }
    }

    // }

    // Step 3
    const step3Result = validateStep3(invoice, uploadedFiles, reportDetails, checkOuttime, checkIntime);
    // Check which step has errors and navigate to it
    const inputDate = new Date(checkOuttime);
    const formattedDate =
      checkOuttime ? inputDate?.toLocaleString("sv-SE")?.replace("T", " ") : '';
    const data = {
      isNeedToConfirm: false,
      reportHeaderId: reportDetails?.reportHeader.reportHeaderId,
      platform: "web",
      platformAppType: null,
      // taskPhotos: uploadedFiles.taskPhotos.filter(
      //   (item: any) => typeof item === "string"
      // ),
      // taskPhotos: uploadedFiles.taskPhotos
      //   ?.filter((item: any) => {
      //     if (typeof item !== "object" || item.reportHdrImageId == null) return false;

      //     // const alreadyExists = reportDetails?.taskPhotos?.some(
      //     //   (existing: any) => existing.reportHdrImageId === item.reportHdrImageId
      //     // );

      //     // return !alreadyExists;
      //   })
      //   .map((item: any, index:number) => 
      //     ({"img": item.imageUrl,
      //     "displayOrder": item?.displayOrder ?? index + 1})
      //   ),
      taskPhotos: uploadedFiles.taskPhotos
        ?.filter((item: any) => typeof item === "object" && item.reportHdrImageId != null)
        .map((item: any, index: number) => ({
          img: item.imageUrl,
          displayOrder: item?.displayOrde ?? index + 1
        })),

      invoiceDetails: {
        spentFoodAmt: invoice.food,
        spentBarAmt: invoice.bar,
        spentGamingAmt: invoice.gaming,
        totalSpentAmt: invoice.total,
      },
      // archieveImages: archieveImages,
      // invoicePhotos: uploadedFiles.invoiceReceipt.filter(
      //   (item: any) => typeof item === "string"
      // ),
      invoicePhotos: uploadedFiles.invoiceReceipt
        ?.filter((item: any) => {
          if (typeof item !== "object" || item.reportHdrInvoiceId == null) return false;

          const alreadyExists = reportDetails?.invoicePhotos?.some(
            (existing: any) => existing.reportHdrInvoiceId === item.reportHdrInvoiceId
          );

          return !alreadyExists;
        })
        .map((item: any) => item.imageUrl),

      ...(formattedDate && uploadedFiles.checkOutFile?.join(", ") && {
        locationDetails: {
          checkOutPhotoUrl: uploadedFiles.checkOutFile?.join(", "),
          checkOutDateTime: formattedDate,
        }
      }),
      ...(reportDetails?.reportHeader?.allocationClientGroup === "ALDI" && {
        shopperBagImages: uploadedFiles.shopperBagImages?.join(","),
      }),
    };


    try {
      if ((localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor')) {
        await submitStep1()
        await submitStep2()
        localStorage.removeItem("ScoreCardStep1");
        localStorage.removeItem("ScoreCardStep2");
      }
      const storedData = localStorage.getItem("ScoreCardStep1");
      const resultObject = storedData ? JSON.parse(storedData) : null;

      const questionAnswerData = localStorage.getItem("ScoreCardStep2");
      const questionAnswerObject = questionAnswerData
        ? JSON.parse(questionAnswerData)
        : null;

      if (resultObject !== null) {
        const responseStep1 = await ApiScoreCardStep1(
          resultObject,
          clientGroup
        );
      }
      // localStorage.removeItem("ScoreCardStep1");
      if (questionAnswerObject && questionAnswerObject.questions.length > 0) {
        const responseStep2 = await ApiScoreCardStep2(
          questionAnswerObject,
          clientGroup
        );
        localStorage.removeItem("ScoreCardStep2");
      }
      const responseStep3 = await ApiScoreCardStep3(data, clientGroup);

      // if (!step1Result.isValid) {
      //   setValidationErrors(step1Result.errors);
      //   setShowValidationErrors(true);
      //   setCurrentStep(1); // Navigate to step 1
      //   return;
      // } else if (step2HasErrors) {
      //   setValidationErrors(allCategoriesValidation);
      //   setShowValidationErrors(true);
      //   setCurrentStep(2); // Navigate to step 2
      //   setCurrentCategoryIndex(errorCategoryIndex); // Navigate to the specific category with errors
      //   return;
      // } else if (!step3Result.isValid) {
      //   setValidationErrors(step3Result.errors);
      //   setShowValidationErrors(true);
      //   setCurrentStep(3); // Navigate to step 3
      //   return;
      // }
      validationResult.isValid = true;
      // Clear all localStorage data for this scorecard when successfully submitted
      localStorage.removeItem(`scorecard_${allocationId}`);
      localStorage.removeItem("scoreCardAnswers");
      localStorage.removeItem("scoreCardUploadedFiles");
      localStorage.removeItem("currentStep");
      localStorage.removeItem(`isScoreCardEdited_${allocationId}`);

      toast.success("Score card Saved successfully");
      if ((localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'clientadmin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor')) {
        if (isClose) {
          await downloadScorecard()
          localStorage.removeItem("selectedVenue")
          window.close()
        }
      }
      else {
        if (isClose) {
          navigate("/dashboard/mytasks")
        }
      }
      //navigate("/dashboard/mytask");
    } catch (error) {
      console.error("Error submitting score card:", error);
      toast.error("Failed to submit score card. Please try again.");
    }

    // If no validation errors, proceed with submiss
    // await fetchData();

    // If no validation errors, show the preview
    // setShowPreview(true);
  };

  const deleteallocation = async () => {
    if (isDemoAllocation && isAdmin) {
      const isConfirm = window.confirm("Are you sure you want to delete this allocation?");
      if (isConfirm) {
        const data = `?allocationId=${reportDetails?.reportHeader?.allocationId}`
        // console.log("DeleteData", data)
        try {
          const res = await ApiDeleteAllocation(data)
          toast.success(res.data)
          localStorage.removeItem("ScoreCardStep1");
          localStorage.removeItem("ScoreCardStep2");
          localStorage.removeItem(`scorecard_${allocationId}`);
          localStorage.removeItem("scoreCardAnswers");
          localStorage.removeItem("scoreCardUploadedFiles");
          localStorage.removeItem("currentStep");
          localStorage.removeItem(`isScoreCardEdited_${allocationId}`)
          localStorage.removeItem("selectedVenue")
          window.close()

        } catch (error: any) {
          toast.error(error?.message)
        }
      }
    }
    else {
      toast.error("Invalid Access")
    }
  }



  const scrollToOverview = (overviewTitle: string) => {
    overviewRefs.current[overviewTitle]?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleAIReview = async () => {
    // if (isAdmin) {
    //   if (editorAiReviewCount > 1) {
    //     setOpenReviewCompleted(true)
    //     return
    //   }
    // }

    // if (isreviewd || (isAdmin && (editorAiReviewCount > 1))) {
    //   setOpenReviewCompleted(true)
    //   return
    // }
    const validationResult = { isValid: true, errors: [] };
    const step1Result = validateStep1(
      reportDetails,
      clientGroup,
      date,
      inspectiontime,
      ratings,
      reportDetails?.starRatingResponseData || [],
      staffMemberDesc,
      additionalNoteForShopper,
      textInputs,
      addOnQuestions,
      reportDetails?.briefJsonDataResponse || [],
      reportDetails?.addOnQuestion || [],
      uploadedFiles,
      checkIntime,
      npsData
    );

    // Step 2 Validation
    const allCategoriesValidation: any[] = [];
    let step2HasErrors = false;
    let errorCategoryIndex = -1;
    const errorMap = new Map<string, any>();

    if (reportDetails) {
      // ALDI/TRANSPORT custom validation
      const orderedQuestions = Array.from(
        new Map(
          reportDetails.questions
            .flatMap((category: any) =>
              category.questions.map((q: any) => ({
                ...q,
                categoryName: category.categoryName,
              }))
            )
            .map((q: any) => [q.questionId, q]) // deduplicate
        ).values()
      )
        .filter((q: any) => q.displayOrder !== undefined)
        .sort((a: any, b: any) => a.displayOrder - b.displayOrder);

      for (let i = 0; i < orderedQuestions.length; i++) {
        const question: any = orderedQuestions[i];
        const categoryIndex = reportDetails.questions.findIndex(
          (cat: any) => cat.categoryName === question.categoryName
        );

        const categoryValidation = AldivalidateStep2(answers, reportDetails);
        if (!categoryValidation.isValid) {
          step2HasErrors = true;
          if (errorCategoryIndex === -1) {
            errorCategoryIndex = categoryIndex;
          }
          (categoryValidation.errors || []).forEach((err: any) => {
            const key = `${err.field}-${err.message}`;
            if (!errorMap.has(key)) {
              errorMap.set(key, err);
            }
          });

        }
      }
    }
    // allCategoriesValidation.push(...(categoryValidation.errors || []))
    allCategoriesValidation.push(...errorMap.values());


    // Step 3 Validation
    const step3Result = validateStep3(
      invoice,
      uploadedFiles,
      reportDetails,
      checkOuttime,
      checkIntime
    );

    // ⛔ STOP here if validation failed
    if (!step1Result.isValid) {
      setValidationErrors(step1Result.errors);
      setShowValidationErrors(true);
      setOpenAllFeildRequired(true)
      if (!isAdmin) {
        setNavigationStep(1)
        // setCurrentStep(1);
      }
      return;
    } else if (step2HasErrors) {
      setValidationErrors(allCategoriesValidation);
      setShowValidationErrors(true);
      setOpenAllFeildRequired(true)
      if (!isAdmin) {
        setNavigationStep(2)
        // setCurrentStep(2);
      }
      setCurrentCategoryIndex(errorCategoryIndex);
      return;
    } else if (!step3Result.isValid) {
      setValidationErrors(step3Result.errors);
      setShowValidationErrors(true);
      setOpenAllFeildRequired(true)
      if (!isAdmin) {
        setNavigationStep(3)
        // setCurrentStep(3);
      }
      return;
    }

    try {
      const data2 = `?reportHeaderId=${reportDetails?.reportHeader?.reportHeaderId}`
      // const data2 = {
      //   reportHeaderId: reportDetails?.reportHeader?.reportHeaderId
      // }
      const res = await ApiReviewReport2(data2, clientGroup);
      if (res?.success) {
        // setAiReview(res?.data?.issues)
        if (isAdmin) {
          setEditorAiReviewCount((prev) => prev + 1)
          setIsReviewed(true)
        }
        else {
          setIsReviewed(true)
        }
        setAiReview(res?.data)
        res?.data && setopenReview(true)
      }

    } catch (error: any) {
      toast.error(error?.message)
    }

  }
  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <Box
            className='bg-alternate'
            sx={{

              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              p: { xs: 2, sm: 3 },
            }}
          >
            <RateYourExperience
              ref={rateRef}
              AiReviews={AiReview}
              date={date}
              reportDetails={reportDetails}
              inspectiontime={inspectiontime}
              ratings={ratings}
              starRatings={reportDetails?.starRatingResponseData || []}
              staffMemberDesc={staffMemberDesc}
              setStaffMemberDesc={setStaffMemberDesc}
              additionalNoteForShopper={additionalNoteForShopper}
              managerId={managerId}
              scenarioId={scenarioId}
              setManagerId={setManagerId}
              npsData={npsData}
              setnpsData={setnpsData}
              setScenarioId={setScenarioId}
              setAdditionalNoteForShopper={setAdditionalNoteForShopper}
              textInputs={textInputs}
              reportGroup={reportDetails?.reportHeader?.allocationClientGroup}
              briefJson={reportDetails?.briefJsonDataResponse || []}
              shopTypeDetail={reportDetails?.shopTypeDetail || []}
              addOnQuestions={addOnQuestions}
              addOnQuestionsData={reportDetails?.addOnQuestion || []}
              reportDetailsHeader={reportDetails?.reportHeader || null}
              reportOtherDetails={reportDetails?.reportOtherDetails}
              setDate={setDate}
              setInspectionTime={setInspectionTime}
              venueName={reportDetails?.venueName}
              clientGroup={reportDetails?.reportHeader?.allocationClientGroup}
              onRatingChange={handleRatingChange}
              onTextChange={handleTextChange}
              onAddOnQuestionChange={handleAddOnQuestionChange}
              validationErrors={validationErrors}
              uploadedFiles={uploadedFiles}
              onFileUpload={handleFileUpload}
              onFileUpdate={handleFileUpdate}
              onRemoveFile={handleRemoveFile}
              setUploadedFiles={setUploadedFiles}
              reorderFile={reorderFiles}
              checkIntime={checkIntime}
              setcheckIntime={setcheckIntime}
              setselectedVenueData={setselectedVenueData}
            />
          </Box>
        );
      case 2:
        return (
          <QuestionsBank
            ref={questionBankRef}
            AiReviews={AiReview}
            questionsData={reportDetails}
            currentCategoryIndex={currentCategoryIndex}
            uploadedFiles={uploadedFiles}
            answers={answers}
            reportGroup={reportDetails?.reportHeader?.allocationClientGroup}
            setAnswer={setAnswers}
            staffMemberDesc={staffMemberDesc}
            setStaffMemberDesc={setStaffMemberDesc}
            clientGroup={reportDetails?.reportHeader?.allocationClientGroup}
            setUploadedFiles={setUploadedFiles}
            reorderFiles={reorderFiles}
            onAnswerChange={handleAnswerChange}
            onCommentChange={handleCommentChange}
            onFileUpload={handleFileUpload}
            onFileUpdate={handleFileUpdate}
            reportOtherDetails={reportDetails?.reportOtherDetails}
            onPreviousCategory={handlePreviousCategory}
            onNextCategory={handleNextCategory}
            onRemoveFile={handleRemoveFile}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            setShowValidationErrors={setShowValidationErrors}
            setCurrentCategoryIndex={setCurrentCategoryIndex}
            setArchieveImages={setarchieveImages}
            archieveImages={archieveImages}
            setSelectedMoveImages={setSelectedMoveImages}
            clientEntityName={clientEntityName}
            oldmaxScore={oldmaxScore}

          />
        );
      case 3:
        return (
          <Box
            sx={{
              bgcolor: "#ADB7921A",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              p: 3,
            }}
          >
            <OtherDetailsScoreCard
              invoice={invoice}
              setInvoice={setInvoice}
              reportDetails={reportDetails}
              uploadedFiles={uploadedFiles}
              onFileUpload={handleFileUpload}
              onFileUpdate={handleFileUpdate}
              onRemoveFile={handleRemoveFile}
              validationErrors={validationErrors}
              setArchieveImages={setarchieveImages}
              archieveImages={archieveImages}
              setUploadedFiles={setUploadedFiles}
              checkOuttime={checkOuttime}
              setcheckOuttime={setcheckOuttime}
              reorderFile={reorderFiles}
              date={date}
              reportGroup={reportDetails?.reportHeader?.allocationClientGroup}
              reportDetailsHeader={reportDetails?.reportHeader || null}
              clientEntityName={clientEntityName}
              moveinvoicetotaskphotos={moveinvoicetotaskphotos}
              checkIntime={checkIntime}
            />
          </Box>
        );
      default:
        return (
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              p: { xs: 2, md: 3 },
            }}
          >
            <RateYourExperience
              ref={rateRef}
              date={date}
              reportDetails={reportDetails}
              inspectiontime={inspectiontime}
              ratings={ratings}
              AiReviews={AiReview}
              starRatings={reportDetails?.starRatingResponseData || []}
              staffMemberDesc={staffMemberDesc}
              setStaffMemberDesc={setStaffMemberDesc}
              additionalNoteForShopper={additionalNoteForShopper}
              managerId={managerId}
              scenarioId={scenarioId}
              setManagerId={setManagerId}
              npsData={npsData}
              setnpsData={setnpsData}
              setScenarioId={setScenarioId}
              setAdditionalNoteForShopper={setAdditionalNoteForShopper}
              clientGroup={reportDetails?.reportHeader?.allocationClientGroup}
              textInputs={textInputs}
              reportDetailsHeader={reportDetails?.reportHeader || null}
              reportOtherDetails={reportDetails?.reportOtherDetails}
              briefJson={reportDetails?.briefJsonDataResponse || []}
              addOnQuestions={addOnQuestions}
              addOnQuestionsData={reportDetails?.addOnQuestion || []}
              setDate={setDate}
              setInspectionTime={setInspectionTime}
              venueName={reportDetails?.venueName}
              onRatingChange={handleRatingChange}
              onTextChange={handleTextChange}
              onAddOnQuestionChange={handleAddOnQuestionChange}
              validationErrors={validationErrors}
              setselectedVenueData={setselectedVenueData}
            />
          </Box>
        );
    }
  };
  useEffect(() => {
    if (localStorage.getItem('liveuserRole') === 'admin' ||
      localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem('liveuserRole') === 'editor') {
      setCurrentStep(totalSteps);
    }
  }, [totalSteps]);

  const CheckError = () => {

    const step1Result = validateStep1(
      reportDetails,
      clientGroup,
      date,
      inspectiontime,
      ratings,
      reportDetails?.starRatingResponseData || [],
      staffMemberDesc,
      additionalNoteForShopper,
      textInputs,
      addOnQuestions,
      reportDetails?.briefJsonDataResponse || [],
      reportDetails?.addOnQuestion || [],
      uploadedFiles,
      checkIntime,
      npsData
    );
    const allCategoriesValidation: any = [];
    let step2HasErrors = false;
    let errorCategoryIndex = -1;

    if (reportDetails) {
      // Flatten all questions with category info, deduplicate, and sort by displayOrder
      const orderedQuestions = Array.from(
        new Map(
          reportDetails.questions
            .flatMap((category: any) =>
              category.questions.map((q: any) => ({
                ...q,
                categoryName: category.categoryName,
              }))
            )
            .map((q: any) => [q.questionId, q]) // deduplicate by questionId
        ).values()
      )
        .filter((q: any) => q.displayOrder !== undefined)
        .sort((a: any, b: any) => a.displayOrder - b.displayOrder);

      for (let i = 0; i < orderedQuestions.length; i++) {
        const question: any = orderedQuestions[i];

        // Find the category index for this question
        const categoryIndex = reportDetails.questions.findIndex(
          (cat: any) => cat.categoryName === question.categoryName
        );

        const categoryValidation = AldivalidateStep2(answers, reportDetails);

        if (!categoryValidation.isValid) {
          step2HasErrors = true;
          if (errorCategoryIndex === -1) {
            errorCategoryIndex = categoryIndex; // store first category with errors
          }
          allCategoriesValidation.push(...(categoryValidation.errors || []));
        }
      }
    }
    // if (step2HasErrors) {
    //   setValidationErrors(allCategoriesValidation);
    //   setShowValidationErrors(true);
    //   setCurrentCategoryIndex(errorCategoryIndex);
    //   return;
    // }
    const step3Result = validateStep3(
      invoice,
      uploadedFiles,
      reportDetails,
      checkOuttime,
      checkIntime
    );

    if (!step1Result.isValid) {
      setValidationErrors(step1Result.errors);
      setShowValidationErrors(true);
      return;
    }
    if (step2HasErrors) {
      setValidationErrors(allCategoriesValidation);
      setShowValidationErrors(true);
      setCurrentCategoryIndex(errorCategoryIndex);
      return;
    }
    if (!step3Result.isValid) {
      setValidationErrors(step3Result.errors);
      setShowValidationErrors(true);
      return;
    }
    setisSuccess(true)

  }

  const handleSelectChange = (newValue: any) => {
    setSelectedQuestion(newValue);
  };


  const getUniqueLabels = (questionsData: any, reportGroup: string) => {
    let allQuestions: any[] = [];

    if (reportGroup === "MM" || reportGroup === "EXTENDED" || reportGroup === "JBHIFI") {
      // Sort categories first by name
      // const sortedCategories = [...questionsData.questions].sort((a, b) =>
      //   a.categoryName.localeCompare(b.categoryName)
      // );
      const sortedCategories = Array.from(
        new Map(
          questionsData?.questions.map((item: any) => [item?.categoryName, item])
        ).values()
      );

      sortedCategories.forEach((category: any) => {
        const sortedQs = [...category?.questions].sort(
          (a, b) => a?.displayOrder - b?.displayOrder
        );
        allQuestions.push(...sortedQs);
        // console.log("Sorted Questions ----->", sorte)
      });
      // console.log("Sorted Categories --->", sortedCategories)
    } else {
      // Direct sort by displayOrder
      questionsData?.questions?.forEach((category: any) => {
        allQuestions?.push(...category.questions);
      });
      allQuestions?.sort((a, b) => a?.displayOrder - b?.displayOrder);
    }

    // Generate unique labels
    const uniqueLabels = Array.from(
      new Set(allQuestions.map((q, index) => `  ${(reportGroup === "MM" || reportGroup === "EXTENDED" || reportGroup === "JBHIFI") ? index + 1 : q?.displayOrder}: ${q?.questions}`))
    );

    return uniqueLabels;
  };

  // Usage
  const uniqueLabels = getUniqueLabels(reportDetails, clientGroup);
  //
  // let counter = 1;
  // const uniqueLabels = Array.from(
  //   new Set(
  //     reportDetails?.questions.flatMap((question: any) =>
  //       question.questions.map((q: any) => `${counter++}: ${q.questions}`)
  //     )
  //   )
  // )
  const aldiuniqueLabels = Array.from(
    new Set(
      reportDetails?.questions.flatMap((question: any) =>
        question.questions.map((q: any) => `${q.questionLabel}: ${q.questions}`)
      )
    )
  );

  const handleScroll2 = async (questionId: string) => {
    setopenReview(false)
    if (!isAdmin) {
      setCurrentStep(2)
      setTimeout(() => {
        questionBankRef.current?.scrollToQuestion(questionId ?? "14652");
      }, 100);
      return
    }
    await questionBankRef.current?.scrollToQuestion(questionId ?? "14652");

  };

  const handleScroll = (briefJsonId: string) => {
    setopenReview(false)
    if (!isAdmin) {
      setCurrentStep(1)
      setTimeout(() => {
        rateRef.current?.scrollToSummaryField(briefJsonId); // pass reportBriefJsonId
      }, 100);
      return
    }
    rateRef.current?.scrollToSummaryField(briefJsonId); // pass reportBriefJsonId
  };

  const renderAdminStep = () => {
    return (
      <Box className='d-flex align-items-start gap-2'>

        <Box
          sx={{
            bgcolor: "#ADB7921A",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            p: 3,
          }}
          flex={1}
          ref={topRef}
        >
          <RateYourExperience
            ref={rateRef}
            date={date}
            overviewRefs={overviewRefs}
            AiReviews={AiReview}
            reportDetails={reportDetails}
            inspectiontime={inspectiontime}
            ratings={ratings}
            starRatings={reportDetails?.starRatingResponseData || []}
            staffMemberDesc={staffMemberDesc}
            setStaffMemberDesc={setStaffMemberDesc}
            additionalNoteForShopper={additionalNoteForShopper}
            managerId={managerId}
            scenarioId={scenarioId}
            setManagerId={setManagerId}
            npsData={npsData}
            setnpsData={setnpsData}
            setScenarioId={setScenarioId}
            setAdditionalNoteForShopper={setAdditionalNoteForShopper}
            textInputs={textInputs}
            reportGroup={reportDetails?.reportHeader?.allocationClientGroup}
            briefJson={reportDetails?.briefJsonDataResponse || []}
            shopTypeDetail={reportDetails?.shopTypeDetail || []}
            addOnQuestions={addOnQuestions}
            addOnQuestionsData={reportDetails?.addOnQuestion || []}
            reportDetailsHeader={reportDetails?.reportHeader || null}
            reportOtherDetails={reportDetails?.reportOtherDetails}
            setDate={setDate}
            setInspectionTime={setInspectionTime}
            venueName={reportDetails?.venueName}
            clientGroup={reportDetails?.reportHeader?.allocationClientGroup}
            onRatingChange={handleRatingChange}
            onTextChange={handleTextChange}
            onAddOnQuestionChange={handleAddOnQuestionChange}
            validationErrors={validationErrors}
            uploadedFiles={uploadedFiles}
            onFileUpload={handleFileUpload}
            onFileUpdate={handleFileUpdate}
            onRemoveFile={handleRemoveFile}
            setUploadedFiles={setUploadedFiles}
            reorderFile={reorderFiles}
            checkIntime={checkIntime}
            setcheckIntime={setcheckIntime}
            setselectedVenueData={setselectedVenueData}
          />
          <Box className='mt-3'>
            {reportDetails && (
              <QuestionsBank
                ref={questionBankRef}
                questionsData={reportDetails}
                AiReviews={AiReview}
                currentCategoryIndex={currentCategoryIndex}
                uploadedFiles={uploadedFiles}
                answers={answers}
                reportGroup={reportDetails?.reportHeader?.allocationClientGroup}
                setAnswer={setAnswers}
                staffMemberDesc={staffMemberDesc}
                setStaffMemberDesc={setStaffMemberDesc}
                clientGroup={reportDetails?.reportHeader?.allocationClientGroup}
                setUploadedFiles={setUploadedFiles}
                reorderFiles={reorderFiles}
                onAnswerChange={handleAnswerChange}
                onCommentChange={handleCommentChange}
                onFileUpload={handleFileUpload}
                onFileUpdate={handleFileUpdate}
                reportOtherDetails={reportDetails?.reportOtherDetails}
                onPreviousCategory={handlePreviousCategory}
                onNextCategory={handleNextCategory}
                onRemoveFile={handleRemoveFile}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                setShowValidationErrors={setShowValidationErrors}
                setCurrentCategoryIndex={setCurrentCategoryIndex}
                setArchieveImages={setarchieveImages}
                archieveImages={archieveImages}
                setSelectedMoveImages={setSelectedMoveImages}
                clientEntityName={clientEntityName}
                oldmaxScore={oldmaxScore}
                selected={selectedQuestion}
              />)}
          </Box>
          <Box className='mt-3'>
            <OtherDetailsScoreCard
              invoice={invoice}
              setInvoice={setInvoice}
              reportDetails={reportDetails}
              uploadedFiles={uploadedFiles}
              onFileUpload={handleFileUpload}
              onFileUpdate={handleFileUpdate}
              onRemoveFile={handleRemoveFile}
              validationErrors={validationErrors}
              setArchieveImages={setarchieveImages}
              archieveImages={archieveImages}
              setUploadedFiles={setUploadedFiles}
              checkOuttime={checkOuttime}
              setcheckOuttime={setcheckOuttime}
              reorderFile={reorderFiles}
              date={date}
              reportGroup={reportDetails?.reportHeader?.allocationClientGroup}
              reportDetailsHeader={reportDetails?.reportHeader || null}
              clientEntityName={clientEntityName}
              moveinvoicetotaskphotos={moveinvoicetotaskphotos}
              checkIntime={checkIntime}

            />
          </Box>
          <Box ref={bottomRef}></Box>
        </Box>
        {(localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") || 'editor') && (
          <Box position={'sticky'} top={'10px'} display={{ xs: "none", md: "flex" }} className='flex-column align-items-center mb-2 justify-content-end' gap={2}>
            {/* <a href={`/all-images/${localstring}`} target="__blank"><Button  sx={{fontSize:'14px !important'}} className="button-primary px-3  py-2">{'View All Images'}</Button></a>  */}
            <Button onClick={() => CheckError()} className="button-primary px-4 py-2">{isSuccess ? "Success" : 'Verify'}</Button>
            <IconButton className="border text-light" onClick={() => topRef.current?.scrollIntoView({ behavior: "smooth" })}><KeyboardArrowUp /></IconButton>
            <IconButton className="border text-light"
              onClick={() => bottomRef.current?.scrollIntoView({ behavior: "smooth" })}><KeyboardArrowDown /></IconButton>


          </Box>
        )}
      </Box>
    );
  };

  // Add a useEffect to persist question answers and uploaded files in localStorage when navigating between steps
  useEffect(() => {
    if (currentStep === 2) {
      // Save the current state of answers and uploadedFiles to localStorage
      localStorage.setItem("scoreCardAnswers", JSON.stringify(answers));
      localStorage.setItem(
        "scoreCardUploadedFiles",
        JSON.stringify(uploadedFiles)
      );
    }
  }, [currentStep, answers, uploadedFiles]);

  const handleOpenCheckoutpopup = () => {
    setisOpenCheckOut(true)
  }

  const setShow = () => {
    setShowPreview(false)
  }

  const handleCancel = () => {
    setClosing(true);

    // Wait for animation to finish
    setTimeout(() => {
      setClosing(false);
      setopenReview(false);
    }, 300);
  };

  // const getDisplayOrderById = (questionId: number) => {
  //   if (!reportDetails) return
  //   return reportDetails?.questions
  //     .flatMap((category: any) =>
  //       category?.questions.map((q: any) => ({
  //         ...q,
  //         categoryName: category?.categoryName,
  //       }))
  //     )
  //     .find((q: any) => q.questionId === questionId)?.displayOrder;
  // };

  const getDisplayOrderById = (
    questionId: number,
  ) => {
    let allQuestions: any[] = [];

    // Build the same ordered question list as getUniqueLabels()
    if (
      clientGroup === "MM" ||
      clientGroup === "EXTENDED" ||
      clientGroup === "JBHIFI"
    ) {
      // Remove duplicate categories by categoryName
      const sortedCategories = Array.from(
        new Map(
          reportDetails?.questions.map((item: any) => [
            item?.categoryName,
            item,
          ])
        ).values()
      );

      sortedCategories.forEach((category: any) => {
        const sortedQs = [...category?.questions].sort(
          (a, b) => a?.displayOrder - b?.displayOrder
        );
        allQuestions.push(...sortedQs);
      });
    } else {
      // Flatten all questions and sort by displayOrder
      reportDetails?.questions?.forEach((category: any) => {
        allQuestions.push(...category.questions);
      });

      allQuestions.sort(
        (a, b) => a?.displayOrder - b?.displayOrder
      );
    }

    // Find the question index in the ordered list
    const index = allQuestions.findIndex(
      (q: any) => q?.questionId === questionId
    );

    if (index === -1) return "";

    const question = allQuestions[index];

    // Generate label using the exact same logic as getUniqueLabels()
    return `${clientGroup === "MM" ||
      clientGroup === "EXTENDED" ||
      clientGroup === "JBHIFI"
      ? index + 1
      : question?.displayOrder
      }`;
  };

  return (
    <>
      {showPreview ? (
        <PreviewScoreCard
          // Data states
          date={date}
          ratings={ratings}
          starRatings={reportDetails?.starRatingResponseData || []}
          staffMemberDesc={staffMemberDesc}
          textInputs={textInputs}
          briefJson={reportDetails?.briefJsonDataResponse || []}
          addOnQuestions={addOnQuestions}
          addOnQuestionsData={reportDetails?.addOnQuestion || []}
          reportDetailsHeader={reportDetails?.reportHeader || null}
          uploadedFiles={uploadedFiles}
          answers={answers}
          invoice={invoice}
          reportDetails={reportDetails}
          currentCategoryIndex={currentCategoryIndex}
          // Functions
          setDate={setDate}
          setStaffMemberDesc={setStaffMemberDesc}
          handleRatingChange={handleRatingChange}
          handleTextChange={handleTextChange}
          handleAddOnQuestionChange={handleAddOnQuestionChange}
          setAnswers={setAnswers}
          setUploadedFiles={setUploadedFiles}
          handleAnswerChange={handleAnswerChange}
          handleCommentChange={handleCommentChange}
          handleFileUpload={handleFileUpload}
          handlePreviousCategory={handlePreviousCategory}
          handleNextCategory={handleNextCategory}
          handleRemoveFile={handleRemoveFile}
          setInvoice={setInvoice}
          // Navigation
          setPreviousStep={handlePreviousStep}
          onSubmit={handleOpenCheckoutpopup}
          onCancel={() => setShowPreview(false)}
          onSyncDataToServer={handleSyncDataToServer}
          validationErrors={validationErrors}
          showPreview={showPreview}
          handlePreviousStep={handlePreviousStep}
          setShow={setShow}
        />

      ) : (
        <>
          <Box
            sx={{
              height: (localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor' || localStorage.getItem("liveuserRole") === 'clientadmin')
                ? "100dvh"
                : "calc(100dvh - 70px)",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#fff",
              WebkitOverflowScrolling: "touch",
              paddingBottom: "env(safe-area-inset-bottom)",
              paddingTop: "env(safe-area-inset-top)",
            }}
          >
            {/* Fixed Top Bar */}
            <Box
              sx={{
                flexShrink: 0,
                px: 2,
                py: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#fff",
                // boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Button
                variant="text"
                sx={{
                  color: "#ADB792",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  fontSize: "14px",
                  textTransform: "none",
                }}
                onClick={() => {
                  if ((localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem('liveuserRole') === 'clientadmin' || localStorage.getItem("liveuserRole") === 'editor')) {
                    localStorage.removeItem("selectedVenue")
                    window.close()
                  }
                  else {
                    localStorage.removeItem("selectedVenue")
                    navigate(-1)
                  }
                }}
              >
                <span style={{ fontSize: "18px", color: "#ADB792" }}>
                  &larr;
                </span>
                <span style={{ textDecoration: "underline" }}>Exit report</span>
              </Button>
              <Typography px={{ xs: 2, lg: 5 }} fontSize={{ xs: '12px', lg: "18px" }} fontWeight={'bolder'} className="py-2 mx-2  border-10 bg-alternate"><span className="fw-bold" style={{ fontWeight: "bolder" }}>{clientGroup == "MM" || clientGroup == "BLOOMS" ? "Do not use your Membership Card. " : ""}Your report could be checked on CCTV to validate your comments and movements.</span></Typography>
              <Button
                variant="text"
                onClick={handleSyncDataToServer}
                sx={{
                  color: "#000000",
                  fontSize: "14px",
                  textTransform: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
                startIcon={
                  <SyncIcon sx={{ fontSize: "16px", color: "#666" }} />
                }
              >
                Sync Now
              </Button>

              {AiReview?.overallReportScore && (
                <IconButton className="m-0" onClick={() => { setopenReview(true) }}>
                  <img className="animate-issue" height={'58px'} width={'58px'} src={issue} alt="Issue"></img>
                </IconButton>
              )}


            </Box>

            {(localStorage.getItem('liveuserRole') === 'admin' ||
              localStorage.getItem('liveuserRole') === 'superadmin' ||
              localStorage.getItem('liveuserRole') === 'editor') && (
                <Box className='d-flex align-items-center mb-0 mx-5'>
                  <Autocomplete
                    fullWidth
                    className=""
                    value={
                      selectedQuestion
                    }
                    onChange={(event, newValue) => {
                      setSelectedQuestion(newValue);
                      handleSelectChange(newValue); // update state
                    }}
                    options={clientGroup === "ALDI" ? aldiuniqueLabels : uniqueLabels}
                    getOptionLabel={(option) =>
                      option
                    }

                    freeSolo
                    sx={{
                      bgcolor: "white",
                      // width: "100%",
                      position: 'sticky',
                      top: '0px',
                      zIndex: 99

                    }}
                    // slotProps={{
                    //   popper: {
                    //     sx: {
                    //       width: "83% !important",
                    //       "& .MuiAutocomplete-paper": {
                    //         width: "83% !important",
                    //         minWidth: "400px",
                    //       },
                    //     },
                    //   },
                    // }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder={"search question here..."}
                        onFocus={() => setFocused(true)}
                        onBlur={() => setFocused(false)}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton className="m-0 p-0">
                                <Search />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                  {/* {AiReview?.overallReportScore && (
                    <IconButton className="m-0" onClick={() => { setopenReview(true) }}>
                      <img className="animate-issue" height={'58px'} width={'58px'} src={issue} alt="Issue"></img>
                    </IconButton>
                  )} */}
                </Box>
              )}

            {/* Scrollable Content */}
            <Box className='d-flex flex-column' sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
              <Divider
                sx={{ borderBottomWidth: "3px", borderColor: "#00000033" }}
              />

              <Container maxWidth="xxl" sx={{ flex: 1, py: 1 }}>
                <Box className='h-100'>
                  {(localStorage.getItem('liveuserRole') === 'admin' ||
                    localStorage.getItem('liveuserRole') === 'superadmin' ||
                    localStorage.getItem('liveuserRole') === 'editor')
                    ? renderAdminStep()
                    : renderCurrentStep()
                  }
                  {/* {renderCurrentStep()} */}
                  {/* Bottom Padding to ensure content not hidden behind fixed footer */}
                  {/* <Box sx={{ height: "100px" }} /> */}
                </Box>

                {/* {loading && <Loading />} */}
              </Container>
            </Box>

            {/* Fixed Bottom Bar */}
            <Box
              sx={{
                flexShrink: 0,
                // p: 2,
                overflow: 'auto',
                backgroundColor: "#fff",
                borderTop: "1px solid #ccc",
                textAlign: "center",
                display: "flex",
                alignItems: 'center',
                justifyContent: "space-between",
                px: 4,
                pt: 1
              }}
            >
              {(currentStep > 1 && liveuser !== 'admin' && liveuser !== 'superadmin' && liveuser !== 'editor') ? (
                <Button
                  variant="outlined"
                  className="py-2 fs-16 px-3 m-2 button-secondary-outlined"
                  onClick={handlePreviousStep}
                  sx={{
                    fontWeight: "500",
                  }}
                >
                  Go Back
                </Button>
              ) : (
                <Box />
              )}

              {
                (isDemoAllocation && isAdmin) ?
                  (
                    <Box className='d-flex align-items-center gap-3 mb-2'>
                      <Button
                        variant="contained"
                        className="button-primary py-2 fs-16 px-3"
                        onClick={() => { downloadReport(true) }}
                        sx={{ maxHeight: '70px' }}
                      >
                        Download Report
                      </Button>
                      <Button
                        variant="contained"
                        className="button-primary py-2 fs-16 px-3"
                        onClick={() => { deleteallocation() }}
                        sx={{ maxHeight: '70px' }}
                      >
                        Delete allocation
                      </Button>

                    </Box>
                  )
                  :
                  (currentStep === totalSteps || localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor') ? (
                    <Box className='d-flex align-items-center gap-3 mb-2'>
                      <Button
                        variant="contained"
                        className="button-primary py-2 fs-16 px-3"
                        onClick={() => { handleSubmit(false) }}
                        sx={{ maxHeight: '70px' }}
                      >
                        Save
                      </Button>
                      <Button
                        variant="contained"
                        className="button-primary py-2 fs-16 px-3"
                        onClick={() => handleSubmit(true)}
                        sx={{ maxHeight: '70px' }}
                      >
                        Save and Close
                      </Button>
                      <Button
                        variant="contained"
                        className="button-primary py-2 fs-16 px-3"
                        onClick={() => { handleFinalSubmit() }}
                        sx={{ maxHeight: '70px' }}
                      >
                        Submit Report
                      </Button>
                      <Box className='d-flex align-items-center justify-content-between' gap={'10px'}>
                        {reportDetails?.allocationDetails?.clientEntityId?.isAISummaryRequired && (
                          <Button
                            variant="contained"
                            className="button-primary py-2 fs-16 px-3"
                            onClick={() => { handleAIReview() }}
                            sx={{ maxHeight: '70px' }}
                          >
                            AI Review
                          </Button>
                        )}
                        {(localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor') && (
                          <Button
                            variant="contained"
                            className="button-primary py-2 fs-16 px-3"
                            onClick={() => { setOpenVenueDescription(true) }}
                            sx={{ maxHeight: '70px' }}
                          >
                            View Brief
                          </Button>
                        )}
                      </Box>
                    </Box>
                  ) : (
                    <Box className='d-flex align-items-center gap-2'>
                      <Button
                        variant="contained"
                        className="custom-bg py-1 fs-16 mb-1"
                        sx={{ maxHeight: '90px' }}
                        onClick={handleSyncDataToServer}
                      >
                        Save
                      </Button>
                      <Button
                        variant="contained"
                        className="custom-bg py-1 fs-16 mb-1"
                        sx={{ maxHeight: '90px' }}
                        onClick={handleNextStep}
                      >
                        Save & Continue
                      </Button>
                    </Box>
                  )}
            </Box>

            {loading && <Loading />}
            {contactdetails &&
              <Dialog sx={{ maxWidth: "500px", mx: 'auto' }} open={openpopup && !isAdmin}>
                {/* <DialogActions className="d-flex m-0 justify-content-end w-100">
                <IconButton onClick={() => setopenpopup(false)}>
                  <CloseOutlined />
                </IconButton>
              </DialogActions> */}
                <ErrorOutline className="mt-2" sx={{ fontSize: '60px' }} />
                <DialogContent className="py-0">
                  <Typography variant="h5" className="text-center  text-main" fontWeight='bold' >Important Info</Typography>
                  <Box className='mb-2 mt-4'>
                    <Typography className="text-center">For any queries regarding the brief for MM, Blooms or Transport (e.g. spend value, questions about the store/venue and task requirements), please email
                      <span className="d-flex justify-content-center"> <a className="text-main" href='mailto:shoppers@mysterymanagement.com.au' target="__blank">
                        shoppers@mysterymanagement.com.au
                      </a>.</span>

                      {/* <span className="d-flex justify-content-center">
                        {contactdetails?.editorDetails.length > 0 ? contactdetails.editorDetails.map((editor, index) => (
                          <Typography key={index}>
                            <a className="text-main" href={`mailto:${editor?.emailId}`}>
                              {editor?.emailId}
                            </a>
                            <span>{index !== contactdetails?.editorDetails.length - 1 && ','}&nbsp;</span>
                          </Typography>


                        )) : 'N/A'}
                      </span> */}
                    </Typography>
                    <hr />

                    <Typography className="text-center">For any queries regarding the brief for ALDI (e.g. spend value, questions about the store/venue and task requirements), please email
                      <span className="d-flex justify-content-center">
                        {reportDetails?.entityTypeDetails?.entityTypeName === "Liquor ID" ?
                          (<a className="text-main" href='mailto:kim@mysterymanagement.com.au' target="__blank">
                            kim@mysterymanagement.com.au
                          </a>) :
                          (<a className="text-main" href='mailto:bryan@mysterymanagement.com.au' target="__blank">
                            bryan@mysterymanagement.com.au
                          </a>
                          )} .</span>

                      {/* <span className="d-flex justify-content-center">
                        {contactdetails?.editorDetails.length > 0 ? contactdetails.editorDetails.map((editor, index) => (
                          <Typography key={index}>
                            <a className="text-main" href={`mailto:${editor?.emailId}`}>
                              {editor?.emailId}
                            </a>
                            <span>{index !== contactdetails?.editorDetails.length - 1 && ','}&nbsp;</span>
                          </Typography>


                        )) : 'N/A'}
                      </span> */}
                    </Typography>
                    <hr />
                    <Typography className="text-center">
                      For any urgent enquiries (e.g. the venue is closed, a safety issue) phone <span className="fw-bold">02 9522 6965</span>
                    </Typography>
                    <hr />
                    {/* <hr />
                    <Typography className="text-center">For any enquires regarding the brief (spend value, questions about the venue and what is required), please contact <a className="text-main" href={`mailto:${contactdetails?.manager?.email}`}>
                      {contactdetails?.manager?.email}
                    </a>
                    </Typography>
                    <hr />
                    <Typography className="text-center"> For any urgent enquires (venue closed) please contact Louise on <a className="text-light custom-bg" href={`mailto:${contactdetails?.owner?.email}`}>
                      {contactdetails?.owner?.email}
                    </a>
                    </Typography> */}
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => { setopenpopup(false); (reportDetails?.lastReportShopperRatingData?.commentForShopper && reportDetails?.lastReportShopperRatingData?.commentForShopper.trim() != "" && setOpenReviewPopup(true)); }} className="button-primary mb-2  px-3 py-2">OK</Button>
                </DialogActions>

              </Dialog>}
            {openreviewpopup &&
              <Dialog sx={{ maxWidth: "700px", mx: 'auto' }} open={openreviewpopup && !isAdmin}>
                {/* <DialogActions className="d-flex m-0 justify-content-end w-100">
                <IconButton onClick={() => setopenpopup(false)}>
                  <CloseOutlined />
                </IconButton>
              </DialogActions> */}
                {/* <ErrorOutline className="mt-2" sx={{ fontSize: '60px' }} /> */}
                <Typography variant="h5" className="text-center  text-main my-4" fontWeight='bold' >Previous Report Feedback</Typography>
                <DialogContent className="py-0">
                  <Box className='mb-2 mt-4'>
                    <div dangerouslySetInnerHTML={{ __html: reportDetails?.lastReportShopperRatingData?.commentForShopper }} />
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => { setOpenReviewPopup(false); }} className="button-primary mb-2  px-3 py-2">OK</Button>
                </DialogActions>

              </Dialog>}


            {/* {AiReview?.length > 0 && */}
            <Dialog sx={{ maxWidth: "1000px", mx: 'auto' }} open={openReview}>
              <DialogActions className="d-flex m-0 justify-content-between w-100 p-4">
                <Box className='d-flex align-items-center' gap={1}>
                  <ErrorTwoTone sx={{ fontSize: '60px', fill: "rgb(240,156,62) !important" }} />
                  <Typography variant="h4" className="text-center  text-main" fontWeight='bold' >{reportDetails?.venueName} AI Summary</Typography>
                </Box>
                <IconButton onClick={() => handleCancel()}>
                  <CloseOutlined />
                </IconButton>
              </DialogActions>
              <Divider className="w-100 mt-0 mx-4" sx={{ border: "1px solid #000000" }} />

              <DialogContent className="py-0">
                {AiReview ? (
                  <Box className='my-4'>
                    <Box className='row gap-2'>
                      <Box className="fs-12 col fw-bold border-10" sx={{ p: 2, background: '#0be2242A' }}>
                        <Typography className="fs-12 text-center" gutterBottom>Overall Report Score</Typography>
                        <Typography className="fs-18 fw-bold text-center m-0 p-0" sx={{ color: "#066c12" }}>{AiReview?.overallReportScore ?? "-"}/10</Typography>
                      </Box>
                      <Box className="fs-12 col fw-bold border-10" sx={{ p: 2, background: '#0b5de22a' }}>
                        <Typography className="fs-12 text-center" gutterBottom>Client Value Score</Typography>
                        <Typography className="fs-18 text-center fw-bold" sx={{ color: '#043077' }}>{AiReview?.clientValueScore ?? "-"}/10</Typography>
                      </Box>
                      <Box className="fs-12 col fw-bold border-10" sx={{ p: 2, background: '#c5e20b2a' }}>
                        <Typography className="fs-12 text-center" gutterBottom>Evidence Quality Score</Typography>
                        <Typography className="fs-18 text-center fw-bold" sx={{ color: "#afc205" }}>{AiReview?.evidenceQualityScore ?? "-"}/10</Typography>
                      </Box>
                      <Box className="fs-12 col border-10 fw-bold" sx={{ p: 2, background: '#0be2b72a' }}>
                        <Typography className="fs-12 text-center" gutterBottom>Photo Alignment Score</Typography>
                        <Typography className="fs-18 text-center fw-bold" sx={{ color: '#089a7d' }}>{AiReview?.photoAlignmentScore ?? "-"}/10</Typography>
                      </Box>
                    </Box>

                    <Grid container spacing={1} alignItems={'stretch !importatant'} className="mt-2">
                      <Grid item xs={6} className="fw-bold h-100">
                        <Grid container className="p-3 mb-3 h-100 border-10" justifyContent={'space-between'} bgcolor={'#ADB7922A'}>
                          <Grid xs={12} className="d-flex align-items-start" gap={'20px'}>
                            <Box>
                              <Box className='d-flex gap-2 align-items-center mb-3'>
                                <CheckCircle sx={{ fontSize: '35px', fill: "#ADB792 !important" }} />
                                <Typography className="fw-bold fs-18" color="#ADB792">Strengths</Typography>
                              </Box>
                              {/* <Typography>{item?.issue}</Typography> */}
                              <ul>
                                {AiReview?.strengths?.map((item: string) => (
                                  <li className="fw-medium fs-12 mb-2">{item}</li>
                                ))}
                              </ul>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={6} className="fw-bold">
                        <Grid container className="p-3 mb-3 border-10" justifyContent={'space-between'} bgcolor={'#BF613B2A'}>
                          <Grid xs={12} className="d-flex align-items-start" gap={'20px'}>
                            <Box>
                              <Box className='d-flex gap-2 align-items-center mb-3'>
                                <ReportProblemOutlined sx={{ fontSize: '35px', fill: "#BF613B !important" }} />
                                <Typography className="fw-bold fs-18" color="#BF613B">Weaknesses</Typography>
                              </Box>
                              {/* <Typography>{item?.issue}</Typography> */}
                              <ul>
                                {AiReview?.weaknesses?.map((item: string) => (
                                  <li className="fw-medium fs-12 mb-2">{item}</li>
                                ))}
                              </ul>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container rowSpacing={2} className="mt-2">
                      <Grid item xs={12} className="border-10 d-flex align-items-start p-2 fw-bold" gap={"20px"} sx={{ background: "#c5e20b2a" }}>
                        <ErrorTwoTone sx={{ fontSize: '35px', fill: "#818505 !important" }} />
                        <Box>
                          <Typography className="fs-18 fw-bold">Contradictions</Typography>
                          <ul>
                            {AiReview?.contradictions?.map((item: string) => (
                              <li className="fw-medium fs-12 mb-2">{item}</li>
                            ))}
                          </ul>
                        </Box>
                      </Grid>
                      <Grid item xs={12} className="fw-bold">
                        <Grid container className="p-3 mb-3 border-10" justifyContent={'space-between'} bgcolor={'#7C9FB22A'}>
                          <Grid xs={12} className="d-flex align-items-start" gap={'20px'}>
                            <DescriptionOutlined sx={{ fontSize: '35px', fill: "#7C9FB2 !important" }} />
                            <Box>
                              <Box className='d-flex align-items-center justify-content-between mb-2'>
                                <Typography className="fs-18 fw-bold">Explanation</Typography>
                                <Typography className="fs-16 fw-bold">{AiReview?.recommendedAction}</Typography>

                              </Box>
                              <Typography className="fs-12">{AiReview?.explanation}</Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    {AiReview?.summaryIssues?.filter((summary: any) => summary.reportOverviewId)?.map((item: any) => (
                      <>
                        <Box className='mb-2' sx={{ cursor: 'pointer' }}>
                          <Box className='d-flex align-items-center mb-1' gap={'10px'}>
                            <Box flex={1}>
                              <Typography variant="body2" className="fw-bold bg-danger text-white px-2 py-1 border-10" width={'fit-content'}>Summary</Typography>
                              <Typography className="fw-bold" gutterBottom>{item?.title}</Typography>
                            </Box>
                            <Tooltip title='Click to jump directly to this question and fix the response'>
                              <IconButton onClick={() => { handleScroll(item?.reportOverviewId) }} sx={{
                                background: '#ADB792', borderRadius: '10px', '&:hover': {
                                  background: '#ADB792', // same color on hover
                                }
                              }}>
                                <NavigateNext />
                              </IconButton>
                            </Tooltip>
                          </Box>
                          <Grid container className="p-3 mb-3 border-10" justifyContent={'space-between'} bgcolor={'#BF613B2A'}>
                            <Grid xs={12} className="d-flex align-items-start" gap={'20px'}>
                              <ReportProblemOutlined sx={{ fontSize: '35px', fill: "#BF613B !important" }} />
                              <Box>
                                <Typography variant="body2" className="fw-bold" color="#BF613B">Issue</Typography>
                                <Typography className="fs-12">{item?.issue}</Typography>
                              </Box>
                            </Grid>
                          </Grid>

                          <Grid container className="p-3 mb-3 border-10" justifyContent={'space-between'} bgcolor={'#7C9FB22A'}>
                            <Grid xs={12} className="d-flex align-items-start" gap={'20px'}>
                              <DescriptionOutlined sx={{ fontSize: '35px', fill: "#7C9FB2 !important" }} />
                              <Box>
                                <Typography variant="body2" className="fw-bold">Description</Typography>
                                <Typography className="fs-12">{item?.description}</Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                        <hr />
                      </>
                    ))}
                    {AiReview?.questionIssues?.map((item: any) => (
                      <>
                        <Box className='mb-2' sx={{ cursor: 'pointer' }}>
                          <Box className='d-flex align-items-center mb-1' gap={'10px'}>
                            <Box flex={1}>
                              <Typography variant="body2" className="fw-bold bg-danger text-white px-2 py-1 border-10" width={'fit-content'}>{getDisplayOrderById(item?.questionId)}. Question</Typography>
                              <Typography className="fw-bold fs-14" gutterBottom>{item?.questionLabel}</Typography>
                            </Box>
                            <Tooltip title='Click to jump directly to this question and fix the response'>
                              <IconButton onClick={() => { handleScroll2(item?.questionId) }} sx={{
                                background: '#ADB792', borderRadius: '10px', '&:hover': {
                                  background: '#ADB792', // same color on hover
                                }
                              }}>
                                <NavigateNext />
                              </IconButton>
                            </Tooltip>
                          </Box>
                          {/* <Grid container className="p-3 mb-3 px-4 border-10" justifyContent={'space-between'} bgcolor={'#f09d3e2A'}>
                          <Grid xs={6} borderRight={'1px solid #ccc'}>
                            <Typography variant="body2" gutterBottom>Score</Typography>
                            <Typography variant="h5" className="fw-bold" color="#ADB792">{item?.reportOverviewId ? "-" : item?.maxScore != 0 ? `${item?.score} / ${item?.maxScore}` : "N/A"}</Typography>
                          </Grid>
                          <Grid xs={5}>
                            <Typography variant="body2" gutterBottom>Severity</Typography>
                            <Typography variant="body1" width={'fit-content'} className="px-3 fw-bold py-1 border-10" color="#f09d3e" bgcolor={'#f09d3e2A'}>{item?.severity}</Typography>
                          </Grid>
                        </Grid> */}
                          <Grid container className="p-3 mb-3 border-10" justifyContent={'space-between'} bgcolor={'#BF613B2A'}>
                            <Grid xs={12} className="d-flex align-items-start" gap={'20px'}>
                              <ReportProblemOutlined sx={{ fontSize: '35px', fill: "#BF613B !important" }} />
                              <Box>
                                <Typography variant="body2" className="fw-bold" color="#BF613B">Issue</Typography>
                                <Typography className="fs-12">{item?.issue}</Typography>
                              </Box>
                            </Grid>
                          </Grid>

                          <Grid container className="p-3 mb-3 border-10" justifyContent={'space-between'} bgcolor={'#7C9FB22A'}>
                            <Grid xs={12} className="d-flex align-items-start" gap={'20px'}>
                              <DescriptionOutlined sx={{ fontSize: '35px', fill: "#7C9FB2 !important" }} />
                              <Box>
                                <Typography variant="body2" className="fw-bold">Description</Typography>
                                <Typography className="fs-12">{item?.description}</Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                        <hr />
                      </>
                    ))}
                    {/* <span dangerouslySetInnerHTML={AiReview}/> */}
                    {/* <span
                    dangerouslySetInnerHTML={{ __html: AiReview }}
                  /> */}
                  </Box>
                ) : (
                  <Typography className="text-center my-5" variant="h4">No Issue found</Typography>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => { handleCancel() }} className="button-primary mb-2  px-3 py-2">OK</Button>
              </DialogActions>

            </Dialog>
            {/* // } */}

            {openVenueDescription && (
              <Dialog open={openVenueDescription}>
                <DialogActions className="d-flex m-0 justify-content-end w-100">
                  <IconButton onClick={() => setOpenVenueDescription(false)}>
                    <CloseOutlined />
                  </IconButton>
                </DialogActions>
                <DialogContent className="py-0">
                  <Box className='mb-2 mt-4'>
                    <div dangerouslySetInnerHTML={{ __html: selecetdvenueData?.venueDescription }} />
                  </Box>
                </DialogContent>
              </Dialog>
            )}

            <Dialog sx={{ maxWidth: "600px", mx: 'auto' }} open={openReviewRequired}>
              <DialogContent className="py-0">
                <Box className='mb-2 mt-4'>
                  <Box className='d-flex align-items-center justify-content-between'>
                    <Typography variant="h6" className="fw-bold">Please do AI review once before submitting report</Typography>
                    <IconButton className="m-0 p-0" onClick={() => { setOpenReviewRequired(false) }}>
                      <Close />
                    </IconButton>
                  </Box>
                  <Typography variant="body1" className="mt-3"><b>Please note:</b> AI is a support tool and may not always be correct. Review each suggestion carefully and use your own judgement.</Typography>
                  <Typography variant="body1" className="mt-3">If you know the information in your report is accurate, you may override or ignore the AI suggestion. Running the AI Check will not automatically change your report.</Typography>
                  <Typography variant="body1" className="mt-3">This check can only be run once before submission.</Typography>
                </Box>
              </DialogContent>
              <DialogActions>
                {/* <Box className='d-flex align-items-center gap-20'> */}
                <Button onClick={() => { setOpenReviewRequired(false) }} className="button-primary mb-2  px-3 py-2">OK</Button>
                {/* </Box> */}
              </DialogActions>

            </Dialog>
            <Dialog sx={{ maxWidth: "600px", mx: 'auto' }} open={openAllFeildRequired}>
              <DialogContent className="py-0">
                <Box className='mb-2 mt-4'>
                  <Box className='d-flex align-items-center justify-content-between'>
                    <Typography variant="h6" className="fw-bold">Report Not Ready for AI Review</Typography>
                    <IconButton className="m-0 p-0" onClick={() => { setOpenAllFeildRequired(false) }}>
                      <Close />
                    </IconButton>
                  </Box>
                  <Typography variant="body1" className="mt-3">Please complete all required fields and fix any validation errors before running the AI Review. We’ve taken you to the first field that needs attention.</Typography>
                </Box>
              </DialogContent>
              <DialogActions>
                {/* <Box className='d-flex align-items-center gap-20'> */}
                <Button onClick={() => { setOpenAllFeildRequired(false); if (!isAdmin) { setCurrentStep(navigationStep || -1) }; }} className="button-primary mb-2  px-3 py-2">OK</Button>
                {/* </Box> */}
              </DialogActions>

            </Dialog>
            <Dialog sx={{ maxWidth: "600px", mx: 'auto' }} open={openReviewCompleted}>
              <DialogContent className="py-0">
                <Box className='mb-2 mt-4'>
                  <Box className='d-flex align-items-center justify-content-between'>
                    <Typography variant="h6" className="fw-bold">AI Review Already Completed</Typography>
                    <IconButton className="m-0 p-0" onClick={() => { setOpenReviewCompleted(false) }}>
                      <Close />
                    </IconButton>
                  </Box>
                  <Typography variant="body1" className="mt-3">You have already completed the AI Review for this report.The AI Check can only be run {isAdmin ? "twice" : "once"} before submission.</Typography>
                </Box>
              </DialogContent>
              <DialogActions>
                {/* <Box className='d-flex align-items-center gap-20'> */}
                <Button onClick={() => { setOpenReviewCompleted(false); }} className="button-primary mb-2  px-3 py-2">OK</Button>
                {/* </Box> */}
              </DialogActions>

            </Dialog>
          </Box>
        </>
      )}
      {/* <Dialog className="mx-auto" sx={{ maxWidth: '500px' }} open={isOpenCheckOut}>
        <Box className="p-3 d-flex flex-column gap-5 px-4">
          <h3 className="text-center">Reminder</h3>
          <Typography>Please make sure you checked out before submitting the report.</Typography>
          <Button className="button-primary py-2" onClick={() => { setisOpenCheckOut(false); }>Ok</Button>
        </Box>
      </Dialog> */}
    </>
  );
}
